<template>
  <div>
    <v-card-text style="margin-top: 20px">
      <pbas-data-table
        v-if="provider !== null && provider !== undefined"
        ref="table"
        :dataProvider="provider"
        identifier="claim-submission-claims"
        @error="error = $event"
        :showSelect="false"
        @itemsChanged="setData($event)"
        noActions
        noSearch
      >
        <template
          v-for="header in provider.headers"
          v-slot:[itemSlotFunc(header)]="{ item }"
        >
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'Patient'"
            style="justify-content: center; width: 250px"
          >
            <span
              v-if="
                isReadOnly(item) || claimSubmission.CoverageType === 'SickDay'
              "
            >
              {{ `${item.Patient.FirstName} ${item.Patient.LastName}` }}
            </span>
            <auto-select
              v-else
              :ref="createRef(item, 'Patient')"
              :menu-props="{ contentClass: 'text-left' }"
              dense
              outlined
              :value="item.Patient"
              @change="updateRow($event, item, 'Patient')"
              :items="patients"
              :item-text="
                (item) =>
                  `${item.FirstName} ${item.LastName} (${$helpers.formatDate(
                    item.DateOfBirth
                  )})`
              "
              item-value="Id"
              return-object
              class="required"
              :rules="[$rules.required]"
              label=" "
              @keydown="evaluateShortcut($event, item, 'Patient')"
              @blur="closeMenu(createRef(item, 'Patient'))"
            ></auto-select>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'PlanBenefit'"
            style="justify-content: center; width: 250px"
          >
            <div
              v-if="
                isReadOnly(item) || claimSubmission.CoverageType === 'SickDay'
              "
              style="word-wrap: break-word; white-space: pre-wrap"
            >
              <span
                v-if="
                  planBenefit[item.Identifier] !== null && planBenefit[item.Identifier] !== undefined
                "
              >
                {{
                  `${planBenefit[item.Identifier].Benefit.Code} - ${translate2(
                    planBenefit[item.Identifier].Benefit,
                    "Name"
                  )}`
                }}
              </span>
            </div>
            <auto-select2
              v-else
              :disabled="
                memberGroupIdentityId === null ||
                memberGroupIdentityId === undefined
              "
              :ref="createRef(item, 'PlanBenefit')"
              outlined
              style="min-width: 200px; padding: 0"
              :loading="loadingSearch"
              :menu-props="{ contentClass: 'text-left benefits' }"
              dense
              :value="item.PlanBenefit"
              @change="updateRow($event, item, 'PlanBenefit')"
              :items="
                sortAndAddCategories(
                  planBenefits[item.Identifier],
                  'PlanBenefits'
                )
              "
              class="required"
              :rules="[$rules.required]"
              @keydown="evaluateShortcut($event, item, 'PlanBenefit')"
              label=" "
              @blur="closeMenu(createRef(item, 'PlanBenefit'))"
              hide-no-data
              placeholder="Search by code or name"
              @keyup="onSearch($event, item)"
              :search-input="search[item.Identifier]"
            />
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'CoveredBenefitCategory'"
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{ getCoveredBenefitCategory(item) }}
            </span>
            <auto-select2
              v-else
              :ref="createRef(item, 'CoveredBenefitCategory')"
              :menu-props="{ contentClass: 'text-left' }"
              dense
              outlined
              :value="item.CoveredBenefitCategory"
              @change="updateRow($event, item, 'CoveredBenefitCategory')"
              :items="coveredBenefitCategories[item.Identifier]"
              class="required"
              :rules="[$rules.required]"
              label=" "
            ></auto-select2>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="
              header.type.key === 'CoveredBenefit' &&
              item.CoveredBenefitCategory === 'Dental'
            "
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{
                item.CoveredBenefit
                  ? translate2(
                      item.CoveredBenefit.IsLifestyle
                        ? item.CoveredBenefit.LifestyleBenefit
                        : item.CoveredBenefit.Benefit,
                      "Name"
                    )
                  : ""
              }}
            </span>
            <auto-select
              v-else
              :ref="createRef(item, 'CoveredBenefit')"
              outlined
              style="min-width: 200px; padding: 0"
              :loading="loadingCoveredSearch"
              :menu-props="{ contentClass: 'text-left benefits' }"
              dense
              :value="item.CoveredBenefit"
              @change="updateRow($event, item, 'CoveredBenefit')"
              :items="coveredBenefits[item.Identifier]"
              :item-text="(item) => getCoveredBenefitNameWithCode(item)"
              item-value="Id"
              class="required"
              :rules="[$rules.required]"
              @keydown="evaluateShortcut($event, item, 'CoveredBenefit')"
              label=" "
              @blur="closeMenu(createRef(item, 'CoveredBenefit'))"
              hide-no-data
              placeholder="Search by code or name"
              @keyup="onCoveredSearch($event, item)"
              return-object
              :search-input="coveredSearch[item.Identifier]"
            />
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="
              header.type.key === 'CoveredBenefit' &&
              item.CoveredBenefitCategory !== 'Dental'
            "
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{
                item.CoveredBenefit
                  ? translate2(
                      item.CoveredBenefit.IsLifestyle
                        ? item.CoveredBenefit.LifestyleBenefit
                        : item.CoveredBenefit.Benefit,
                      "Name"
                    )
                  : ""
              }}
            </span>
            <auto-select
              v-else
              :ref="createRef(item, 'CoveredBenefit')"
              :menu-props="{ contentClass: 'text-left' }"
              dense
              outlined
              :value="item.CoveredBenefit"
              @change="updateRow($event, item, 'CoveredBenefit')"
              :items="coveredBenefits[item.Identifier]"
              :item-text="
                (item) =>
                  translate2(
                    item.IsLifestyle ? item.LifestyleBenefit : item.Benefit,
                    'Name'
                  )
              "
              item-value="Id"
              returnObject
              class="required"
              :rules="[$rules.required]"
              label=" "
              @keydown="evaluateShortcut($event, item, 'CoveredBenefit')"
              @blur="closeMenu(createRef(item, 'CoveredBenefit'))"
            ></auto-select>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'DIN'"
            style="justify-content: center; width: 250px"
          >
            <div
              v-if="isReadOnly(item)"
              style="word-wrap: break-word; white-space: pre-wrap"
            >
              {{ displayReadonlyDIN(item) }}
            </div>
            <auto-select2
              v-else
              :ref="createRef(item, 'DIN')"
              outlined
              style="min-width: 200px; padding: 0"
              :loading="loading"
              :menu-props="{ contentClass: 'text-left benefits' }"
              dense
              :value="item.DIN"
              @change="updateRow($event, item, 'DIN')"
              :items="drugs[item.Identifier].map((o) => `${o.Din}-${o.Name}`)"
              :class="
                planBenefit[item.Identifier] &&
                planBenefit[item.Identifier].Benefit.RequiresDIN
                  ? 'required'
                  : ''
              "
              :rules="
                planBenefit[item.Identifier] &&
                planBenefit[item.Identifier].Benefit.RequiresDIN
                  ? [$rules.required]
                  : []
              "
              @keydown="evaluateShortcut($event, item, 'DIN')"
              :label="
                planBenefit[item.Identifier] &&
                planBenefit[item.Identifier].Benefit.RequiresDIN
                  ? ' '
                  : ''
              "
              @blur="closeMenu(createRef(item, 'DIN'))"
              :disabled="isReadOnly(item)"
              hide-no-data
              placeholder="Search by DIN"
              @keyup="onSearchDin($event, item)"
              :search-input="searchDin[item.Identifier]"
            />
            <!-- <no-autocomplete-textfield
              :ref="createRef(item, 'DIN')"
              outlined
              style="min-width:200px;padding:0"
              dense
              :value="item.DIN"
              @input="updateRow($event, item, 'DIN')"
              :rules="[
                $rules.required,
                $rules.numericString,
                $rules.dynamic.length(8),
              ]"
              class="required"
              label=" "
              @keydown="evaluateShortcut($event, item, 'DIN')"
              :disabled="isReadOnly(item)"
            /> -->
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'Quantity'"
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{ item.Quantity }}
            </span>
            <no-autocomplete-textfield
              v-else
              :ref="createRef(item, 'Quantity')"
              outlined
              style="min-width: 200px; padding: 0"
              :value="item.Quantity"
              @input="updateRow($event, item, 'Quantity')"
              dense
              clearable
              class="required"
              :rules="[$rules.required, $rules.integer]"
              label=" "
              @keydown="evaluateShortcut($event, item, 'Quantity')"
              :disabled="isReadOnly(item)"
            />
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'DaysOfSupply'"
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{ item.DaysOfSupply }}
            </span>
            <no-autocomplete-textfield
              v-else
              :ref="createRef(item, 'DaysOfSupply')"
              outlined
              style="min-width: 200px; padding: 0"
              dense
              clearable
              :value="item.DaysOfSupply"
              @input="updateRow($event, item, 'DaysOfSupply')"
              class="required"
              :rules="[$rules.required, $rules.integer]"
              label=" "
              @keydown="evaluateShortcut($event, item, 'DaysOfSupply')"
              :disabled="isReadOnly(item)"
            />
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'BenefitTreatmentSite'"
            style="justify-content: center; width: 250px"
          >
            <span>
              {{
                planBenefit[item.Identifier] &&
                planBenefit[item.Identifier].Benefit.TreatmentSite
                  ? planBenefit[item.Identifier].Benefit.TreatmentSite.Name
                  : ""
              }}
            </span>
            <!-- <no-autocomplete-textfield
              v-else
              outlined
              dense
              style="min-width:200px;padding:0"
              :value="
                item.PlanBenefit && item.PlanBenefit.Benefit.TreatmentSite
                  ? item.PlanBenefit.Benefit.TreatmentSite.Name
                  : null
              "
              disabled
            /> -->
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'ToothCode'"
            style="justify-content: center; width: 250px"
          >
            <!-- <no-autocomplete-textfield
              :ref="createRef(item, 'ToothCode')"
              outlined
              dense
              style="min-width:200px;padding:0"
              :value="item.ToothCode"
              @input="updateRow($event, item, 'ToothCode')"
              :rules="[$rules.numericString, $rules.dynamic.length(2)]"
              @keydown="evaluateShortcut($event, item, 'ToothCode')"
            /> -->
            <span v-if="isReadOnly(item)">
              {{ item.ToothCode ? item.ToothCode.Code : "" }}
            </span>
            <auto-select
              v-else
              :ref="createRef(item, 'ToothCode')"
              outlined
              style="min-width: 200px; padding: 0"
              :loading="loading"
              :menu-props="{ contentClass: 'text-left benefits' }"
              dense
              :value="item.ToothCode"
              @change="updateRow($event, item, 'ToothCode')"
              :items="toothCodes[item.Identifier]"
              :item-text="(item) => (item ? item.Code : '')"
              item-value="Id"
              return-object
              label=" "
              @keydown="evaluateShortcut($event, item, 'ToothCode')"
              @blur="closeMenu(createRef(item, 'ToothCode'))"
              :disabled="isReadOnly(item)"
            />
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'SurfaceCode'"
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{ item.SurfaceCode }}
            </span>
            <no-autocomplete-textfield
              v-else
              :ref="createRef(item, 'SurfaceCode')"
              outlined
              dense
              style="min-width: 200px; padding: 0"
              :value="item.SurfaceCode"
              @input="updateRow($event, item, 'SurfaceCode')"
              :rules="surfacesRules(item.Identifier)"
              @keydown="evaluateShortcut($event, item, 'SurfaceCode')"
              :class="
                planBenefit[item.Identifier] &&
                planBenefit[item.Identifier].Benefit.SurfaceRequired
                  ? 'required'
                  : ''
              "
              :label="
                planBenefit[item.Identifier] &&
                planBenefit[item.Identifier].Benefit.SurfaceRequired
                  ? ' '
                  : ''
              "
              :disabled="isReadOnly(item)"
            />
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'DateOfService'"
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{ item.DateOfService.split("T")[0] }}
            </span>
            <pbas-date-picker
              v-else
              :ref="createRef(item, 'DateOfService')"
              outlined
              style="min-width: 200px; padding: 0"
              :value="item.DateOfService"
              @update-date="updateRow($event, item, 'DateOfService')"
              :rules="
                claimSubmission.IsPredetermined
                  ? []
                  : [$rules.required, rules.allowedSubmissionDates]
              "
              dense
              :class="claimSubmission.IsPredetermined ? '' : 'required'"
              label=" "
              @keydown="evaluateShortcut($event, item, 'DateOfService')"
              :disabled="isReadOnly(item) || claimSubmission.IsPredetermined"
              :allowedDates="allowedSubmissionDates"
            ></pbas-date-picker>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'ReceivedDate'"
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{ item.ReceivedDate.split("T")[0] }}
            </span>
            <pbas-date-picker
              v-else
              :ref="createRef(item, 'ReceivedDate')"
              outlined
              style="min-width: 200px; padding: 0"
              :value="item.ReceivedDate"
              @update-date="updateRow($event, item, 'ReceivedDate')"
              :rules="
                claimSubmission.IsPredetermined
                  ? []
                  : [$rules.required, rules.allowedSubmissionDates]
              "
              dense
              :class="claimSubmission.IsPredetermined ? '' : 'required'"
              label=" "
              @keydown="evaluateShortcut($event, item, 'ReceivedDate')"
              :disabled="isReadOnly(item)"
              :allowedDates="allowedSubmissionDates"
            ></pbas-date-picker>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'ExpenseAmount'"
            style="justify-content: center; width: 250px"
          >
            <v-form :ref="`total${item.Identifier}`">
              <!-- <currency-textfield
                :ref="createRef(item, 'ExpenseAmount')"
                outlined
                style="min-width:200px;padding:0"
                prepend-inner-icon="mdi-currency-usd"
                dense
                :value="item.ExpenseAmount"
                @input="updateRow($event, item, 'ExpenseAmount')"
                placeholder="0.00"
                class="required"
                :rules="[
                  $rules.requiredNum,
                  $rules.notZeroMoney,
                  (val) => rules.greaterOrEqualThanCob(val, item.Identifier),
                ]"
                :error-messages="totalErrorMessages[item.Identifier]"
                label=" "
                @keypress="evaluateShortcut($event, item, 'ExpenseAmount')"
              /> -->
              <!-- <v-currency-field
                :ref="createRef(item, 'ExpenseAmount')"
                outlined
                style="min-width:200px;padding:0"
                prepend-inner-icon="mdi-currency-usd"
                dense
                :value="item.ExpenseAmount"
                @input="updateRow($event, item, 'ExpenseAmount')"
                placeholder="0.00"
                :rules="[
                  $rules.requiredNum,
                  $rules.notZeroMoney,
                  (val) => rules.greaterOrEqualThanCob(val, item.Identifier),
                ]"
                @keypress="evaluateShortcut($event, item, 'ExpenseAmount')"
                label=" "
                :error-messages="totalErrorMessages[item.Identifier]"
                class="required"
              /> -->
              <!-- <currency-textbox
                :ref="createRef(item, 'ExpenseAmount')"
                outlined
                style="min-width:200px;padding:0"
                prepend-inner-icon="mdi-currency-usd"
                dense
                :value="item.ExpenseAmount"
                @input="updateRowAmount($event, item, 'ExpenseAmount')"
                placeholder="0.00"
                :rules="[
                  $rules.requiredNum,
                  $rules.notZeroMoney,
                  (val) => rules.greaterOrEqualThanCob(val, item.Identifier),
                ]"
                @keydown="evaluateShortcut($event, item, 'ExpenseAmount')"
                label=" "
                :error-messages="totalErrorMessages[item.Identifier]"
                class="required"
                :options="currencyOptions"
                :disabled="isReadOnly(item)"
              /> -->
              <span v-if="isReadOnly(item)">
                {{ formatCurrency(item.ExpenseAmount) }}
              </span>
              <no-autocomplete-textfield
                v-else
                :ref="createRef(item, 'ExpenseAmount')"
                outlined
                style="min-width: 200px; padding: 0"
                dense
                label=" "
                :error-messages="totalErrorMessages[item.Identifier]"
                class="required"
                :disabled="isReadOnly(item)"
                :value="item.ExpenseAmount"
                placeholder="0.00"
                :rules="[
                  $rules.requiredNum,
                  $rules.notZeroMoney,
                  (val) => rules.greaterOrEqualThanCob(val, item.Identifier),
                ]"
                prefix="$"
                @keydown="currencyKeydown($event, item, 'ExpenseAmount')"
                @keyup="currencyKeyUp($event, item, 'ExpenseAmount')"
              ></no-autocomplete-textfield>
            </v-form>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'LabFee'"
            style="justify-content: center; width: 250px"
          >
            <v-form :ref="`fee${item.Identifier}`">
              <!-- <currency-textfield
              :ref="createRef(item, 'LabFee')"
              outlined
              style="min-width:200px;padding:0"
              prepend-inner-icon="mdi-currency-usd"
              dense
              :value="item.LabFee"
              @input="updateRow($event, item, 'LabFee')"
              placeholder="0.00"
              :rules="[$rules.notZeroMoney]"
              @keypress="evaluateShortcut($event, item, 'LabFee')"
            /> -->
              <!-- <currency-textbox
              :ref="createRef(item, 'LabFee')"
              outlined
              style="min-width:200px;padding:0"
              prepend-inner-icon="mdi-currency-usd"
              dense
              :value="item.LabFee"
              @input="updateRowAmount($event, item, 'LabFee')"
              placeholder="0.00"
              :rules="[$rules.notZeroMoney]"
              @keydown="evaluateShortcut($event, item, 'LabFee')"
              :options="currencyOptions"
              :disabled="isReadOnly(item)"
            /> -->
              <span v-if="isReadOnly(item)">
                {{ formatCurrency(item.LabFee) }}
              </span>
              <no-autocomplete-textfield
                v-else
                :ref="createRef(item, 'LabFee')"
                outlined
                style="min-width: 200px; padding: 0"
                dense
                label=""
                :disabled="isReadOnly(item)"
                :value="item.LabFee"
                placeholder="0.00"
                :rules="[
                  $rules.notZeroMoney,
                  (val) => rules.feeGreaterOrEqualThanCob(val, item.Identifier),
                ]"
                prefix="$"
                @keydown="currencyKeydown($event, item, 'LabFee')"
                @keyup="currencyKeyUp($event, item, 'LabFee')"
                :error-messages="feeErrorMessages[item.Identifier]"
              ></no-autocomplete-textfield>
            </v-form>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'COBAmount'"
            style="justify-content: center; width: 250px"
          >
            <v-form :ref="`cob${item.Identifier}`">
              <!-- <currency-textfield
                outlined
                style="min-width:200px;padding:0"
                prepend-inner-icon="mdi-currency-usd"
                dense
                :value="item.COBAmount"
                @input="updateRow($event, item, 'COBAmount')"
                placeholder="0.00"
                :rules="[
                  $rules.notZeroMoney,
                  (val) => rules.lessOrEqualThanTotal(val, item.Identifier),
                ]"
                :error-messages="cobErrorMessages[item.Identifier]"
                @keypress="evaluateShortcut($event, item, 'COB')"
              /> -->
              <!-- <currency-textbox
                :ref="createRef(item, 'COBAmount')"
                outlined
                style="min-width:200px;padding:0"
                prepend-inner-icon="mdi-currency-usd"
                dense
                :value="item.COBAmount"
                @input="updateRowAmount($event, item, 'COBAmount')"
                placeholder="0.00"
                :rules="[
                  $rules.notZeroMoney,
                  (val) => rules.lessOrEqualThanTotal(val, item.Identifier),
                ]"
                :error-messages="cobErrorMessages[item.Identifier]"
                @keydown="evaluateShortcut($event, item, 'COBAmount')"
                label=""
                :options="currencyOptions"
                :disabled="isReadOnly(item)"
              /> -->
              <span v-if="isReadOnly(item)">
                {{ formatCurrency(item.COBAmount) }}
              </span>
              <no-autocomplete-textfield
                v-else
                :ref="createRef(item, 'COBAmount')"
                outlined
                style="min-width: 200px; padding: 0"
                dense
                label=""
                :error-messages="cobErrorMessages[item.Identifier]"
                :disabled="isReadOnly(item)"
                :value="item.COBAmount"
                placeholder="0.00"
                :rules="[
                  $rules.notZeroMoney,
                  (val) => rules.lessOrEqualThanTotal(val, item.Identifier),
                ]"
                prefix="$"
                @keydown="currencyKeydown($event, item, 'COBAmount')"
                @keyup="currencyKeyUp($event, item, 'COBAmount')"
              ></no-autocomplete-textfield>
            </v-form>
          </div>

          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'State'"
            style="justify-content: center; width: 250px"
          >
            <span>
              {{ item.State }}
            </span>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'EligibleAmount'"
            style="justify-content: center"
          >
            <span>
              {{ formatCurrency(item.EligibleAmount) }}
            </span>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'PaidAmount'"
            style="justify-content: center"
          >
            <span>
              {{ formatCurrency(item.PaidAmount) }}
            </span>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'DayDuration'"
            style="justify-content: center; width: 250px"
          >
            <span v-if="isReadOnly(item)">
              {{ item.DayDuration }}
            </span>
            <trans-enum
              v-else
              :ref="createRef(item, 'DayDuration')"
              outlined
              style="min-width: 200px; padding: 0"
              :loading="loading"
              :menu-props="{ contentClass: 'text-left benefits' }"
              dense
              :value="item.DayDuration"
              @change="updateRow($event, item, 'DayDuration')"
              :items="options.Enums.DayDurations"
              label=" "
              @keydown="evaluateShortcut($event, item, 'DayDuration')"
              @blur="closeMenu(createRef(item, 'DayDuration'))"
              :disabled="isReadOnly(item)"
              :rules="[$rules.required]"
              class="required"
            ></trans-enum>
          </div>
          <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'Actions'"
            style="justify-content: center"
          >
            <v-menu bottom left style="padding: 0">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" text>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  @click.prevent="action.handler(item)"
                  v-for="action in rowActions(item)"
                  :key="action.name"
                >
                  <v-list-item-title>
                    <v-icon small class="mr-2">{{ action.icon }}</v-icon>
                    {{ $t(action.title) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <!-- <div
            v-bind:key="header.type.key"
            v-if="header.type.key === 'Amount'"
            style="justify-content:center"
          >
            <v-btn
              v-if="index === 0"
              small
              text
              @click.prevent="rowActions[0].handler(item)"
            >
              <v-icon>
                {{ rowActions[0].icon }}
              </v-icon>
              {{ $t(rowActions[0].title) }}
            </v-btn>
            <no-autocomplete-textfield
              clearable
              style="min-width:200px;padding:0"
              :fixedId="'hours-amount-textbox' + item.Identifier"
              v-bind:key="header.type.key"
              :value="item.Amount"
              @input="updateRow($event, item, 'Amount')"
              @keydown="currencyKeydown"
              @keypress="currencyKeyUp($event, item, 'Amount')"
              :rules="
                requiredColumns.indexOf('Amount') > -1 ? [$rules.required] : []
              "
              :class="requiredColumns.indexOf('Amount') > -1 ? 'required' : ''"
              label=" "
            />
            <!-- <currency-textfield
                prefix=""
                cssstyle="min-width:200px;padding:0;margin-top:-13px"
                :fixedId="'hours-amount-textbox'+item.Identifier"
                v-bind:key="header.type.key"
                :value="item.Amount"
                @input="updateRow($event, item, 'Amount')"
                :rules="
                  requiredColumns.indexOf('Amount') > -1 ? [$rules.required] : []
                "
                :class="requiredColumns.indexOf('Amount') > -1 ? 'required' : []"
              /> --
          </div> -->
        </template>
      </pbas-data-table>
    </v-card-text>
    <v-divider />
    <error-handler :error="error"></error-handler>
    <v-dialog v-model="deleteClaimDialog" persistent width="400" class="mx-0">
      <v-card max-width="400">
        <v-card-title class="primary white--text mb-6 py-2">
          <v-icon dark class="mr-2">mdi-delete-forever-outline</v-icon>
          {{ $t("components.new_claim.delete_dialog.title") }}
        </v-card-title>
        <v-card-text class="text-subtitle-1 font-weight-medium">
          {{ $t("components.new_claim.delete_dialog.text") }}
        </v-card-text>
        <v-card-actions class="justify-end pr-6">
          <v-btn
            text
            @click="
              deleteClaimDialog = false;
              claimToDeleteIndex = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" @click="deleteClaim">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable persistent v-model="explainDialog" max-width="1800">
      <material-card
        v-if="explainDialog && item"
        :title="
          $t(
            'components.claims.submitted_submissions_table.explain_claim_line_title_{0}',
            [
              claimSubmission.Claims.findIndex(
                (o) => o.Identifier === item.Identifier
              ) + 1,
            ]
          )
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="description"
      >
        <v-card-text>
          <explanation-of-benefits :claim="item" />
          <v-alert v-if="item.AdjudicationError" dense type="error">
            <span v-if="item.AdjudicationError.code === '900'">
              {{ item.AdjudicationError.message }}
            </span>
            <span v-else>
              {{
                $t(
                  `adjudication_message.${item.AdjudicationError.message}`,
                  item.AdjudicationError.formattedParams
                )
              }}
            </span>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="explainDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent width="400" class="mx-0">
      <v-card max-width="400">
        <v-card-title class="primary white--text mb-6 py-2">
          <v-icon dark class="mr-2">mdi-delete-forever-outline</v-icon>
          {{ $t("components.new_claim.delete_dialog.title") }}
        </v-card-title>
        <v-card-text class="text-subtitle-1 font-weight-medium">
          {{ $t("components.new_claim.delete_dialog.text") }}
        </v-card-text>
        <v-card-actions class="justify-end pr-6">
          <v-btn text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" @click="tryDeleteClaim">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="adjudicateDialog" persistent width="400" class="mx-0">
      <v-card max-width="400">
        <v-card-title class="primary white--text mb-6 py-2">
          <v-icon dark class="mr-2">rules</v-icon>
          {{ $t("components.new_claim.adjudicate_dialog.title") }}
        </v-card-title>
        <v-card-text class="text-subtitle-1 font-weight-medium">
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions class="justify-end pr-6">
          <v-btn text @click="adjudicateDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="tryAdjudicate">
            {{ $t("globals.adjudicate") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="rejectDialog"
      width="400"
      class="mx-0"
      scrollable
      persistent
    >
      <material-card
        v-if="rejectDialog && item"
        :title="$t('components.claims.claims_table.reject_dialog_title')"
        :color="$vuetify.theme.themes.light.primary"
        icon="description"
      >
        <v-card-text>
          <v-form v-model="rejectValid">
            <v-textarea
              v-model="rejectExplanation"
              :rules="[$rules.required]"
              class="required"
              :label="$t('components.claims_history.header.explanation')"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="rejectDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="tryReject" :disabled="!rejectValid">
            {{ $t("views.billingwizard.reject") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="pendDialog"
      width="400"
      class="mx-0"
      scrollable
      persistent
    >
      <material-card
        v-if="pendDialog && item"
        :title="$t('components.claims.claims_table.pend_dialog_title')"
        :color="$vuetify.theme.themes.light.primary"
        icon="description"
      >
        <v-card-text>
          <v-form v-model="pendValid">
            <v-textarea
              v-model="pendExplanation"
              :rules="[$rules.required]"
              class="required"
              :label="$t('components.claims_history.header.explanation')"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="pendDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="tryPend" :disabled="!pendValid">
            {{ $t("components.claims.claims_table.pend") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="warning45Days" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.warning") }}
        </v-card-title>
        <v-card-text>
          {{ $t("views.claims.warning_{0}_days", [daysForWarning]) }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancel45Days">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="warning45Days = false">
            {{ $t("globals.continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import getClaimHeaders from "@/headers/InMemoryClaims";
import { InMemoryProvider } from "pbas-vue-components";
import { translate2 } from "@/trans2";
import { translate } from "@/trans";
import ExplanationOfBenefits from "./ExplanationOfBenefits.vue";
import AutoSelect from "../AutoSelect.vue";
import AutoSelect2 from "../AutoSelect2.vue";
import TransEnum from "../TransEnum.vue";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    ExplanationOfBenefits,
    AutoSelect,
    AutoSelect2,
    TransEnum,
  },
  props: [
    "planIdentityId",
    "claimSubmission",
    "patients",
    "submitted",
    "review",
    "planStartDate",
    "isValidForAdjudicate",
    "memberIdentityId",
    "currentMemberGroupIdentityId",
  ],
  data() {
    return {
      currencyOptions: {
        locale: "en-US",
        currency: "USD",
        currencyDisplay: "hidden",
        precision: 2,
        // hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        useGrouping: true,
        accountingSign: false,
      },
      provider: undefined,
      valid: true,
      error: null,
      cobErrorMessages: {},
      totalErrorMessages: {},
      feeErrorMessages: {},
      rules: {
        surface: (v) => {
          if (!v) {
            return true;
          }
          const msg = this.$t("validation.valid_characters_are_{0}", [
            this.validSurfaceChars.join(", "),
          ]);
          const letters = v.split("");
          const found = [];
          for (const letter of letters) {
            if (this.validSurfaceChars.indexOf(letter) === -1) {
              return msg;
            }
            if (found.indexOf(letter) > -1) {
              return msg;
            } else {
              found.push(letter);
            }
          }
          return true;
        },
        // /M|L|D|B|O/.test(v) ||
        lessOrEqualThanTotal: (v, identifier) => {
          const item = this.provider.items.filter(
            (o) => o.Identifier === identifier
          )[0];
          // console.log(v, item);
          let valid = true;
          let labFee = null;
          if (v !== null && v !== undefined) {
            let cob = parseFloat(v.toString().replaceAll(",", ""));
            if (!isNaN(cob)) {
              if (
                item.ExpenseAmount === null ||
                item.ExpenseAmount === undefined
              ) {
                valid = false;
              } else {
                let total = parseFloat(
                  item.ExpenseAmount.toString().replaceAll(",", "")
                );

                if (
                  (this.claimSubmission.CoverageType === "Dental" ||
                    this.claimSubmission.CoverageType === "Prescription") &&
                  item.LabFee !== null &&
                  item.LabFee !== undefined
                ) {
                  labFee = parseFloat(
                    item.LabFee.toString().replaceAll(",", "")
                  );
                }
                if (isNaN(total)) {
                  valid = false;
                } else {
                  if (!isNaN(labFee)) {
                    total += labFee;
                  }
                  // console.log(cob, total);
                  valid = cob <= total;
                }
              }
            }
          }
          // console.log(valid);
          if (valid) {
            // this.$nextTick(() => {
            this.$refs[`total${item.Identifier}`] &&
              this.$refs[`total${item.Identifier}`][0] &&
              this.$refs[`total${item.Identifier}`][0].resetValidation();
            this.$refs[`fee${item.Identifier}`] &&
              this.$refs[`fee${item.Identifier}`][0] &&
              this.$refs[`fee${item.Identifier}`][0].resetValidation();
            this.$refs[`cob${item.Identifier}`] &&
              this.$refs[`cob${item.Identifier}`][0] &&
              this.$refs[`cob${item.Identifier}`][0].resetValidation();
            // this.$forceUpdate();
            // });

            this.$nextTick(() => {
              this.cobErrorMessages[identifier] = [];
              this.totalErrorMessages[identifier] = [];
              this.feeErrorMessages[identifier] = [];
              this.$forceUpdate();
            });
            this.validate();
            return true;
          }

          this.$nextTick(() => {
            this.cobErrorMessages[identifier] = [
              this.$t("validation.not_grater_than_total_expense"),
            ];
            // if (this.claimSubmission.CoverageType === "Dental") {
            //   this.totalErrorMessages[identifier] = [
            //     this.$t("validation.lab_fee_not_less_than_cob"),
            //   ];
            // } else if (this.claimSubmission.CoverageType === "Prescription") {
            //   this.totalErrorMessages[identifier] = [
            //     this.$t("validation.dispensing_fee_not_less_than_cob"),
            //   ];
            // } else {
            this.totalErrorMessages[identifier] = [
              this.$t("validation.not_less_than_cob"),
            ];
            // }
            // console.log(
            //   "#######################",
            //   labFee,
            //   isNaN(labFee),
            //   labFee === null || isNaN(labFee)
            // );
            if (labFee === null || isNaN(labFee)) {
              this.$refs[`fee${item.Identifier}`] &&
                this.$refs[`fee${item.Identifier}`][0] &&
                this.$refs[`fee${item.Identifier}`][0].resetValidation();
            } else {
              this.feeErrorMessages[identifier] = [
                this.$t("validation.not_less_than_cob"),
              ];
            }
            // else if (this.claimSubmission.CoverageType === "Dental") {
            //   this.feeErrorMessages[identifier] = [""
            //     // this.$t("validation.lab_fee_not_less_than_cob"),
            //   ];
            // } else if (this.claimSubmission.CoverageType === "Prescription") {
            //   this.feeErrorMessages[identifier] = [""
            //     // this.$t("validation.dispensing_fee_not_less_than_cob"),
            //   ];
            // }
            this.$forceUpdate();
          });
          this.$emit("valid", false);
          return this.$t("validation.not_grater_than_total_expense");
        },
        greaterOrEqualThanCob: (v, identifier) => {
          const item = this.provider.items.filter(
            (o) => o.Identifier === identifier
          )[0];
          // console.log(v, item.ExpenseAmount, item.COBAmount);
          let valid = true;
          let labFee = null;
          if (
            v !== null &&
            v !== undefined &&
            item.COBAmount !== null &&
            item.COBAmount !== undefined
          ) {
            let total = parseFloat(v.toString().replaceAll(",", ""));
            let cob = parseFloat(item.COBAmount.toString().replaceAll(",", ""));
            if (
              (this.claimSubmission.CoverageType === "Dental" ||
                this.claimSubmission.CoverageType === "Prescription") &&
              item.LabFee !== null &&
              item.LabFee !== undefined
            ) {
              labFee = parseFloat(item.LabFee.toString().replaceAll(",", ""));
            }
            // console.log(labFee, total, cob);
            if (!isNaN(total) && !isNaN(cob)) {
              // console.log(cob, total);
              if (!isNaN(labFee)) {
                total += labFee;
              }
              valid = cob <= total;
            }
          }
          // console.log(valid);
          if (valid) {
            // this.$nextTick(() => {
            this.$refs[`total${item.Identifier}`] &&
              this.$refs[`total${item.Identifier}`][0] &&
              this.$refs[`total${item.Identifier}`][0].resetValidation();
            this.$refs[`fee${item.Identifier}`] &&
              this.$refs[`fee${item.Identifier}`][0] &&
              this.$refs[`fee${item.Identifier}`][0].resetValidation();
            this.$refs[`cob${item.Identifier}`] &&
              this.$refs[`cob${item.Identifier}`][0] &&
              this.$refs[`cob${item.Identifier}`][0].resetValidation();
            //   this.$forceUpdate();
            // });

            this.$nextTick(() => {
              this.cobErrorMessages[identifier] = [];
              this.totalErrorMessages[identifier] = [];
              this.feeErrorMessages[identifier] = [];
              this.$forceUpdate();
            });
            this.validate();
            return true;
          }
          this.$nextTick(() => {
            this.cobErrorMessages[identifier] = [
              this.$t("validation.not_grater_than_total_expense"),
            ];
            // if (this.claimSubmission.CoverageType === "Dental") {
            //   this.totalErrorMessages[identifier] = [
            //     this.$t("validation.lab_fee_not_less_than_cob"),
            //   ];
            // } else if (this.claimSubmission.CoverageType === "Prescription") {
            //   this.totalErrorMessages[identifier] = [
            //     this.$t("validation.dispensing_fee_not_less_than_cob"),
            //   ];
            // } else {
            this.totalErrorMessages[identifier] = [
              this.$t("validation.not_less_than_cob"),
            ];
            // }
            // console.log(
            //   "#######################",
            //   labFee,
            //   isNaN(labFee),
            //   labFee === null || isNaN(labFee)
            // );
            if (labFee === null || isNaN(labFee)) {
              this.$refs[`fee${item.Identifier}`] &&
                this.$refs[`fee${item.Identifier}`][0] &&
                this.$refs[`fee${item.Identifier}`][0].resetValidation();
            } else {
              this.feeErrorMessages[identifier] = [
                this.$t("validation.not_less_than_cob"),
              ];
            }
            // else if (this.claimSubmission.CoverageType === "Dental") {
            //   this.feeErrorMessages[identifier] = [""
            //     // this.$t("validation.lab_fee_not_less_than_cob"),
            //   ];
            // } else if (this.claimSubmission.CoverageType === "Prescription") {
            //   this.feeErrorMessages[identifier] = [""
            //     // this.$t("validation.dispensing_fee_not_less_than_cob"),
            //   ];
            // }
            this.$forceUpdate();
          });
          this.$emit("valid", false);
          return this.$t("validation.not_less_than_cob");
        },
        feeGreaterOrEqualThanCob: (v, identifier) => {
          const item = this.provider.items.filter(
            (o) => o.Identifier === identifier
          )[0];
          // console.log(
          //   "feeGreaterOrEqualThanCob: ",
          //   v,
          //   item.ExpenseAmount,
          //   item.COBAmount
          // );
          let valid = true;
          let labFee = null;
          if (
            v !== null &&
            v !== undefined &&
            item.COBAmount !== null &&
            item.COBAmount !== undefined &&
            item.ExpenseAmount !== null &&
            item.ExpenseAmount !== undefined
          ) {
            let total = parseFloat(
              item.ExpenseAmount.toString().replaceAll(",", "")
            );
            let cob = parseFloat(item.COBAmount.toString().replaceAll(",", ""));
            labFee = parseFloat(v.toString().replaceAll(",", ""));
            // console.log(labFee, total, cob);
            if (!isNaN(total) && !isNaN(cob)) {
              // console.log(cob, total);
              if (!isNaN(labFee)) {
                total += labFee;
              }
              valid = cob <= total;
            }
          }
          // console.log(valid);
          if (valid) {
            // this.$nextTick(() => {
            this.$refs[`total${item.Identifier}`] &&
              this.$refs[`total${item.Identifier}`][0] &&
              this.$refs[`total${item.Identifier}`][0].resetValidation();
            this.$refs[`fee${item.Identifier}`] &&
              this.$refs[`fee${item.Identifier}`][0] &&
              this.$refs[`fee${item.Identifier}`][0].resetValidation();
            this.$refs[`cob${item.Identifier}`] &&
              this.$refs[`cob${item.Identifier}`][0] &&
              this.$refs[`cob${item.Identifier}`][0].resetValidation();
            //   this.$forceUpdate();
            // });

            this.$nextTick(() => {
              this.cobErrorMessages[identifier] = [];
              this.totalErrorMessages[identifier] = [];
              this.feeErrorMessages[identifier] = [];
              this.$forceUpdate();
            });
            this.validate();
            return true;
          }
          this.$nextTick(() => {
            this.cobErrorMessages[identifier] = [
              this.$t("validation.not_grater_than_total_expense"),
            ];
            // if (this.claimSubmission.CoverageType === "Dental") {
            //   this.totalErrorMessages[identifier] = [
            //     this.$t("validation.lab_fee_not_less_than_cob"),
            //   ];
            // } else if (this.claimSubmission.CoverageType === "Prescription") {
            //   this.totalErrorMessages[identifier] = [
            //     this.$t("validation.dispensing_fee_not_less_than_cob"),
            //   ];
            // } else {
            this.totalErrorMessages[identifier] = [
              this.$t("validation.not_less_than_cob"),
            ];
            // }

            if (labFee === null || isNaN(labFee)) {
              this.$refs[`fee${item.Identifier}`] &&
                this.$refs[`fee${item.Identifier}`][0] &&
                this.$refs[`fee${item.Identifier}`][0].resetValidation();
            } else {
              this.feeErrorMessages[identifier] = [
                this.$t("validation.not_less_than_cob"),
              ];
            }
            // else if (this.claimSubmission.CoverageType === "Dental") {
            //   this.feeErrorMessages[identifier] = [
            //     this.$t("validation.lab_fee_not_less_than_cob"),
            //   ];
            // } else if (this.claimSubmission.CoverageType === "Prescription") {
            //   this.feeErrorMessages[identifier] = [
            //     this.$t("validation.dispensing_fee_not_less_than_cob"),
            //   ];
            // }

            this.$forceUpdate();
          });
          this.$emit("valid", false);
          return this.$t("validation.not_less_than_cob");
        },
        allowedSubmissionDates: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          const firstRenewalDate = this.planStartDate;
          const n2 = Date.parse(firstRenewalDate);
          const d2 = new Date(n2);
          if (!this.isDate(v)) {
            return this.$t("validation.date_{0}", [this.formatDate(d2)]);
          }
          const n = Date.parse(v);
          const d = new Date(n);
          const d3 = new Date();
          return (
            (d <= d3 && d >= d2) ||
            this.$t("validation.date_{0}_{1}", [
              this.formatDate(d2),
              this.formatDate(d3),
            ])
          );
        },
      },
      validSurfaceChars: ["M", "L", "D", "B", "O"],
      loading: false,
      search: {},
      planBenefits: {},
      deleteClaimDialog: false,
      item: null,
      copyRow: null,
      toothCodes: [],
      explainDialog: false,
      deleteDialog: false,
      adjudicateDialog: false,
      searchDin: {},
      drugs: {},
      searchMonitor: null,
      searchMonitorDin: null,
      rejectDialog: false,
      rejectExplanation: null,
      rejectValid: false,
      loadingSearch: false,
      snackbar: false,
      message: null,
      planBenefit: {},
      coveredBenefit: {},
      coveredBenefitCategory: {},
      din: {},
      pendValid: false,
      pendDialog: false,
      pendExplanation: null,
      memberGroupIdentityId: null,
      supportsHalfDays: false,
      sickDaySubmissionSettings: null,
      warning45Days: false,
      sickDayRow: null,
      daysForWarning: 45,
      coveredBenefits: {},
      coveredBenefitCategories: {},
      coveredSearch: {},
      loadingCoveredSearch: false,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options", "planOptions", "planIdentity"]),
    // planBenefits2() {
    //   return this.entries2.map((entry) => {
    //     const Description = translate2(entry.Benefit, "Name");
    //     return Object.assign({}, entry, { Description });
    //   });
    // },
  },
  watch: {
    claimSubmission: {
      async handler(v) {
        console.log("claim submission loaded: ", v);
        if (v) {
          for (let claim of v.Claims) {
            console.log(JSON.parse(JSON.stringify(claim)));
            if (claim.PlanBenefit !== null && claim.PlanBenefit !== undefined) {
              console.log(typeof claim.PlanBenefit);
              if (typeof claim.PlanBenefit === "object") {
                this.planBenefits[claim.Identifier] = [claim.PlanBenefit];
                this.toothCodes[claim.Identifier] =
                  this.options.Models.ToothCode.filter(
                    (o) =>
                      o.TreatmentSiteId ===
                      claim.PlanBenefit.Benefit.TreatmentSiteId
                  );

                this.planBenefit[claim.Identifier] = claim.PlanBenefit;
                console.log(JSON.parse(JSON.stringify(this.planBenefit)));
                console.log(JSON.parse(JSON.stringify(this.planBenefit[claim.Identifier])));
                console.log(claim.Identifier);
                if (this.memberGroupIdentityId === null) {
                  this.memberGroupIdentityId = (
                    await this.getMemberGroupIdentityId({
                      memberIdentityId: this.memberIdentityId,
                      date: claim.DateOfService,
                    })
                  ).data;
                }
              }
            } else {
              this.toothCodes[claim.Identifier] = [];
              this.planBenefits[claim.Identifier] = [];
            }
            console.log(JSON.parse(JSON.stringify(this.planBenefit)));
            console.log(JSON.parse(JSON.stringify(this.planBenefits)));
            // console.log(
            //   "##################################################",
            //   claim.DIN
            // );
            if (claim.DIN !== null && claim.DIN !== undefined) {
              if (typeof claim.DIN === "object") {
                // console.log(claim.DIN);
                this.drugs[claim.Identifier] = [claim.DIN];
                this.din[claim.Identifier] = [claim.DIN];
              }
            } else {
              this.drugs[claim.Identifier] = [];
              this.din[claim.Identifier] = null;
            }
            this.search[claim.Identifier] = null;
            this.searchDin[claim.Identifier] = null;

            if (this.claimSubmission.CoverageType === "HSA") {
              if (
                claim.DateOfService !== null &&
                claim.DateOfService !== undefined &&
                claim.PlanBenefit !== null &&
                claim.PlanBenefit !== undefined
              ) {
                if (typeof claim.PlanBenefit === "object") {
                  this.coveredBenefitCategories[claim.Identifier] =
                    await this.getHsaCategories({
                      coveredBenefitId: claim.PlanBenefit.Id,
                    });
                  this.coveredBenefitCategory[claim.Identifier] =
                    this.getCoveredBenefitCategory(claim);
                  if (
                    this.coveredBenefitCategory[claim.Identifier] === "Dental"
                  ) {
                    this.coveredBenefits[claim.Identifier] = [
                      claim.CoveredBenefit,
                    ];
                  } else {
                    this.coveredBenefits[claim.Identifier] = (
                      await this.getHsaCoveredBenefits({
                        coveredBenefitId: claim.PlanBenefit.Id,
                        category: this.getCoveredBenefitCategory(claim),
                      })
                    ).data.value;
                  }

                  // claim.CoveredBenefitCategory = claim.PlanBenefit.IsLifestyle?claim.PlanBenefit.LifestyleBenefit?.Category:claim.PlanBenefit.Benefit?.Category
                }
                //   this.planBenefits[claim.Identifier] =
                //   (
                //   await this.getPlanBenefitsForClaimSubmission({
                //     dateOfService: claim.DateOfService,
                //     memberIdentityId: this.memberIdentityId,
                //     coverage: this.claimSubmission.CoverageType,
                //   })
                // ).data.value;
              }
            }
            // else {
            //   // await new Promise((resolve) => setTimeout(resolve, 100));
            // }
          }
          // this.$nextTick(() => {
          //     this.$forceUpdate();
          //   });
console.log("claims loaded: ")
          // console.log("claim submission watch - provider: ", this.provider);
          if (this.provider === null || this.provider === undefined) {
            this.provider = new InMemoryProvider(
              JSON.parse(JSON.stringify(this.v.Claims)),
              getClaimHeaders(
                this.claimSubmission.CoverageType,
                this.review,
                this.supportsHalfDays
              )
            );
          }
          if (this.provider !== null && this.provider !== undefined) {
            this.provider.items = JSON.parse(JSON.stringify(v.Claims));
            if (this.provider.items.length > 0) {
              this.provider.items.forEach((item) => {
                if (
                  item.PlanBenefit !== null &&
                  item.PlanBenefit !== undefined &&
                  typeof item.PlanBenefit === "object"
                ) {
                  this.planBenefit[item.Identifier] = item.PlanBenefit;
                  item.PlanBenefit = item.PlanBenefit.Benefit.Code
                    ? `${item.PlanBenefit.Benefit.Code} - ${item.PlanBenefit.Benefit.Name}`
                    : item.PlanBenefit.Benefit.Name;
                }
                item.CoveredBenefitCategory =
                  this.coveredBenefitCategory[item.Identifier];
              });
            }
            console.log("provider items: ", this.provider.items);
            console.log(JSON.parse(JSON.stringify(this.planBenefit)));
            this.$emit("plan-benefit", this.planBenefit);
          }
          this.$refs.table.getDataAsync();
        }
      },
      // deep: true,
      immediate: true,
    },
    // search: {
    //   handler(v, old) {
    //     // console.log("search: ", v, old);
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    // s1: {
    //   handler(v, old) {
    //     console.log(v, old);
    //   },
    //   deep:true, immediate: true
    // }
    "claimSubmission.IsPredetermined": {
      handler(v) {
        let headers = getClaimHeaders(
          this.claimSubmission.CoverageType,
          this.review,
          this.supportsHalfDays
        );
        if (v) {
          headers = headers.filter((o) => o.type.key !== "DateOfService");
          this.memberGroupIdentityId = this.currentMemberGroupIdentityId;
        } else {
          this.memberGroupIdentityId = null;
        }

        this.provider = new InMemoryProvider(
          JSON.parse(JSON.stringify(this.claimSubmission.Claims)),
          headers
        );
        this.valid = this.validate();
        // console.log(this.valid);
        this.$emit("valid", this.valid);
        this.$forceUpdate();
      },
    },
    supportsHalfDays: {
      handler(v) {
        let headers = getClaimHeaders(
          this.claimSubmission.CoverageType,
          this.review,
          v
        );

        this.provider = new InMemoryProvider(
          JSON.parse(JSON.stringify(this.claimSubmission.Claims)),
          headers
        );
      },
    },
  },
  async mounted() {
    // this.options.Enums.DayDurations = ["HalfDay", "FullDay"];

    console.log("mounted: claims table: ", this.supportsHalfDays);
    if (this.submitted) {
      for (const claim of this.claimSubmission.Claims) {
        this.planBenefits[claim.Identifier] = [claim.PlanBenefit];
        this.toothCodes[claim.Identifier] =
          this.options.Models.ToothCode.filter(
            (o) =>
              o.TreatmentSiteId === claim.PlanBenefit.Benefit.TreatmentSiteId
          );
        this.search[claim.Identifier] = null;
        // console.log(
        //   "$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$",
        //   claim.DIN
        // );
        if (claim.DIN !== null && claim.DIN !== undefined) {
          this.drugs[claim.Identifier] = [claim.DIN];
        } else {
          this.drugs[claim.Identifier] = [];
        }
        this.searchDin[claim.Identifier] = null;
      }
    } else {
      this.planBenefits[this.claimSubmission.Claims[0].Identifier] = [];
      this.search[this.claimSubmission.Claims[0].Identifier] = null;
      this.drugs[this.claimSubmission.Claims[0].Identifier] = [];
      this.searchDin[this.claimSubmission.Claims[0].Identifier] = null;
    }
    if (this.claimSubmission.CoverageType === "SickDay") {
      for (let claim of this.claimSubmission.Claims) {
        claim.Patient = this.patients[0];
      }
    }
    if (this.provider === null || this.provider === undefined) {
      this.provider = new InMemoryProvider(
        JSON.parse(JSON.stringify(this.claimSubmission.Claims)),
        getClaimHeaders(
          this.claimSubmission.CoverageType,
          this.review,
          this.supportsHalfDays
        )
      );
    }
    this.valid = this.validate();
    // console.log(this.valid);
    this.$emit("valid", this.valid);
  },
  methods: {
    ...mapActions("claims", [
      "getPlanBenefitsForClaimSubmission",
      "getHsaCoveredBenefits",
      "deleteClaimById",
      "adjudicateClaimById",
      "getPlanDrugsForClaimSubmission",
      "rejectClaimById",
      "pendClaimById",
      "getPlanCoveredBenefits",
      "getMemberGroupIdentityId",
      "getSickDayBenefit",
      "getSickDaySubmissionSettings",
      "getSickHourBankSettings",
      "getHsaBenefitCategories",
    ]),
    // amountBlur(row, key) {
    //   console.log("amount blur: ", row, key);
    // let num = parseFloat(row[key]).toFixed(2);
    // if (!isNaN(num)) {
    //   this.updateRow(num, row, key);
    // }
    // },
    async getHsaCategories(payload) {
      let data = (await (this.getHsaBenefitCategories(payload))).data;
      console.log(data);
          const uniqueSortedCategories = [
            ...new Set(
              data.value
                .filter((item) =>
                  item.IsLifestyle
                    ? item.LifestyleBenefit?.Coverage !== "Dental"
                    : item.Benefit?.Coverage !== "Dental",
                )
                .map((item) =>
                  item.IsLifestyle
                    ? item.LifestyleBenefit?.Category
                    : item.Benefit?.Category,
                )
                .filter(Boolean),
            ),
          ].sort();
          if (
            data.value.filter((item) =>
              item.IsLifestyle
                ? item.LifestyleBenefit?.Coverage === "Dental"
                : item.Benefit?.Coverage === "Dental",
            ).length > 0
          ) {
            uniqueSortedCategories.push("Dental");
          }
          console.log("uniqueSortedCategories", uniqueSortedCategories);
          return uniqueSortedCategories.sort();
    },
    getCoveredBenefitCategory(item) {
      console.log("getCoveredBenefitCategory----------", item)
      console.log(JSON.stringify(item));
      if (item.CoveredBenefit === null || item.CoveredBenefit === undefined) {
        return "";
      }
      let isDental = item.CoveredBenefit.IsLifestyle
        ? item.CoveredBenefit.LifestyleBenefit?.Coverage === "Dental"
        : item.CoveredBenefit.Benefit?.Coverage === "Dental";
      if (isDental) {
        return "Dental";
      }
      return item.CoveredBenefit.IsLifestyle
        ? item.CoveredBenefit.LifestyleBenefit?.Category
        : item.CoveredBenefit.Benefit?.Category;
    },
    formatDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    allowedSubmissionDates(val) {
      // console.log(this.planStartDate);
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.planStartDate);
      const d2 = new Date(n2);
      const d3 = new Date();
      return d3 >= d && d >= d2;
    },
    rowActions(item) {
      const actions = [
        {
          title: "components.expenses_table.actions.new_line",
          name: "add",
          icon: "add",
          handler: () => this.newLine(),
        },
      ];
      if (this.review && item.State !== null && item.State !== undefined) {
        // explain Available always
        actions.push({
          title: "components.expenses_table.actions.explain",
          name: "explain",
          icon: "description",
          handler: (item) => this.explainClaim(item),
        });
        if (item.State === "Pended") {
          // delete Available only when status is Pended
          actions.push({
            title: "globals.delete",
            name: "remove",
            icon: "delete",
            handler: (item) => this.deleteClaimCall(item),
          });
          // adjudicate Available only when status is Pended
          // console.log(
          //   "isValidForAdjudicate: -------------------------------------------------------------------------",
          //   this.isValidForAdjudicate
          // );
          if (this.isValidForAdjudicate) {
            actions.push({
              title: "globals.adjudicate",
              name: "adjudicate",
              icon: "rules",
              handler: (item) => this.adjudicateClaim(item),
            });
          }

          actions.push({
            title: "views.billingwizard.reject",
            name: "reject",
            icon: "description",
            handler: (item) => this.rejectClaim(item),
          });
        } else if (item.State === "Approved") {
          actions.push({
            title: "globals.delete",
            name: "remove",
            icon: "delete",
            handler: (item) => this.deleteClaimCall(item),
          });
          actions.push({
            title: "components.claims.claims_table.pend",
            name: "pend",
            icon: "pending_actions",
            handler: (item) => this.pendClaim(item),
          });
        } else if (item.State === "Rejected") {
          actions.push({
            title: "globals.delete",
            name: "remove",
            icon: "delete",
            handler: (item) => this.deleteClaimCall(item),
          });
          actions.push({
            title: "components.claims.claims_table.pend",
            name: "pend",
            icon: "pending_actions",
            handler: (item) => this.pendClaim(item),
          });
        } else if (item.State === "New" || item.State === "Submitted") {
          actions.splice(1, 0, {
            title: "components.expenses_table.actions.remove_line",
            name: "delete",
            icon: "delete",
            handler: (item) => this.deleteLine(item),
          });
          actions.push({
            title: "globals.delete",
            name: "remove",
            icon: "delete",
            handler: (item) => this.deleteClaimCall(item),
          });
          actions.push({
            title: "views.billingwizard.reject",
            name: "reject",
            icon: "x",
            handler: (item) => this.rejectClaim(item),
          });
        }
      } else {
        actions.push({
          title: "components.expenses_table.actions.remove_line",
          name: "delete",
          icon: "delete",
          handler: (item) => this.deleteLine(item),
        });
      }
      actions.push({
        title: "globals.copy",
        name: "copy",
        icon: "mdi-content-copy",
        handler: (item) => {
          let o = this.provider.items.filter(
            (o) => o.Identifier === item.Identifier
          )[0];
          // console.log(JSON.stringify(o));
          this.copyRow = JSON.parse(JSON.stringify(o));
          // console.log(JSON.stringify(this.copyRow), JSON.stringify(item));
          this.pasteLine();
        },
      });
      return actions;
    },
    surfacesRules(id) {
      let rules = [this.$rules.surface];
      if (this.planBenefit[id]) {
        if (this.planBenefit[id].Benefit.SurfaceRequired) {
          rules.unshift(this.$rules.required);
        }
        if (
          this.planBenefit[id].Benefit.NoOfSurfacesAllowed !== null &&
          this.planBenefit[id].Benefit.NoOfSurfacesAllowed !== undefined
        ) {
          const val = parseInt(
            this.planBenefit[id].Benefit.NoOfSurfacesAllowed
          );
          if (isNaN(val)) {
            rules.push(this.$rules.dynamic.upToLength(5));
          } else {
            rules.push(this.$rules.dynamic.upToLength(val));
          }
        } else {
          rules.push(this.$rules.dynamic.upToLength(5));
        }
      } else {
        rules.push(this.$rules.dynamic.upToLength(5));
      }
    },
    translate(item, language) {
      return translate(item, language);
    },
    closeMenu(ref) {
      // console.log(ref);
      this.$refs[ref][0].isMenuActive = false;
    },
    change(v) {
      this.planBenefit = v;
      // console.log(this.planBenefit);
      console.log("plan benefit change: ", JSON.parse(JSON.stringify(this.planBenefit)));
    },
    hasValue(field) {
      return field !== null && field !== undefined && field !== "";
    },
    cancel45Days() {
      this.warning45Days = false;
      this.item = this.sickDayRow;
      this.deleteClaim(true);
      // this.updateRow(null, this.sickDayRow, "DateOfService");
    },
    async updateRow(value, row, key) {
      // console.log("update row: ", value, row, key);
      if (row === undefined) {
        return;
      }
      const index = this.provider.items.findIndex(
        (o) => o.Identifier === row.Identifier
      );
      // const index = this.provider.items.indexOf(
      //   this.provider.items.filter((o) => o.Identifier === row.Identifier)[0]
      // );
      // console.log(JSON.stringify(this.provider.items[index][key]), value);
      if (this.provider.items[index][key] !== value) {
        console.log(
          "$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$",
          index,
          this.provider.items[index][key],
          value
        );
        if (key === "ReceivedDate") {
          if (this.isDate(value)) {
            let existingDate = this.provider.items[index][key];
            if (
              existingDate === null ||
              existingDate === undefined ||
              existingDate.split("T")[0] !== value.split("T")[0]
            ) {
              this.provider.items[index][key] = value;
              if (
                this.claimSubmission.CoverageType === "SickDay" &&
                this.memberGroupIdentityId !== null &&
                this.memberGroupIdentityId !== undefined &&
                this.provider.items[index].DateOfService !== null &&
                this.provider.items[index].DateOfService !== undefined &&
                this.provider.items[index].DateOfService !== ""
              ) {
                // console.log("received date: ", value);
                let sickDayBankSettings = (
                  await this.getSickHourBankSettings({
                    planIdentityId: this.planIdentityId,
                    memberGroupIdentityId: this.memberGroupIdentityId,
                    dateOfService: this.provider.items[index].DateOfService,
                  })
                ).data;
                if (
                  sickDayBankSettings &&
                  sickDayBankSettings.DaysForWarning !== null &&
                  sickDayBankSettings.DaysForWarning !== undefined
                ) {
                  this.daysForWarning = sickDayBankSettings.DaysForWarning;
                }
                let date45DaysAgo = new Date(
                  value.split("T")[0] + "T00:00:00.000Z"
                );
                date45DaysAgo.setDate(
                  date45DaysAgo.getDate() - this.daysForWarning
                );
                if (
                  new Date(this.provider.items[index].DateOfService) <
                  date45DaysAgo
                ) {
                  this.sickDayRow = row;
                  this.warning45Days = true;
                }
              }
            }
          }
        } else if (key === "DateOfService") {
          if (
            this.isDate(value) &&
            (this.provider.items[index][key] === null ||
              this.provider.items[index][key] === undefined ||
              this.provider.items[index][key].split("T")[0] !==
                value.split("T")[0])
          ) {
            // this.coveredBenefits[row.Identifier] =
            // (
            //     await this.getPlanBenefitsForClaimSubmission({
            //       dateOfService: value,
            //       memberIdentityId: this.memberIdentityId,
            //       coverage: this.claimSubmission.CoverageType,
            //     })
            //   ).data.value;
            // getBenefits(search, id, dateOfService)
            let search = null;
            // if (row.PlanBenefit !== null && row.PlanBenefit !== undefined && typeof row.PlanBenefit !== "object") {
            //   search = row.PlanBenefit.split(" - ")[0];
            // }
            this.getBenefits(search, row.Identifier, value);

            this.memberGroupIdentityId = (
              await this.getMemberGroupIdentityId({
                memberIdentityId: this.memberIdentityId,
                date: value,
              })
            ).data;
            // ---------------- to remove
            // this.memberGroupIdentityId = '74b119cd-a821-4ce1-90ae-3c20ffdc43cf';
            // ----------------
            // console.log(this.memberGroupIdentityId);
            if (
              this.memberGroupIdentityId === null ||
              this.memberGroupIdentityId === undefined ||
              this.memberGroupIdentityId === ""
            ) {
              this.error = {
                customMessage: this.$t("components.claims.no_member_group"),
              };
              this.memberGroupIdentityId = undefined;
            }
            let existingDate = this.provider.items[index][key];
            if (
              existingDate === null ||
              existingDate === undefined ||
              existingDate.split("T")[0] !== value.split("T")[0]
            ) {
              this.provider.items[index][key] = value;

              // const currentDate = this.claimSubmission.Claims.filter(
              //   (o) => o.Identifier === row.Identifier
              // );
              // if (currentDate.length > 0) {
              //   console.log("##############################", currentDate[0].DateOfService, value);
              //   if (currentDate[0].DateOfService !== value) {
              //     this.planBenefits[row.Identifier] = [];
              //     this.provider.items[index].PlanBenefit = undefined;
              //   }
              // } else {
              if (
                this.claimSubmission.CoverageType === "SickDay" &&
                this.memberGroupIdentityId !== null &&
                this.memberGroupIdentityId !== undefined
              ) {
                if (
                  this.provider.items[index].ReceivedDate !== null &&
                  this.provider.items[index].ReceivedDate !== undefined &&
                  this.provider.items[index].ReceivedDate !== ""
                ) {
                  let sickDayBankSettings = (
                    await this.getSickHourBankSettings({
                      planIdentityId: this.planIdentityId,
                      memberGroupIdentityId: this.memberGroupIdentityId,
                      dateOfService: value,
                    })
                  ).data;
                  if (
                    sickDayBankSettings &&
                    sickDayBankSettings.DaysForWarning !== null &&
                    sickDayBankSettings.DaysForWarning !== undefined
                  ) {
                    this.daysForWarning = sickDayBankSettings.DaysForWarning;
                  }
                  let date45DaysAgo = new Date(
                    this.provider.items[index].ReceivedDate.split("T")[0] +
                      "T00:00:00.000Z"
                  );
                  date45DaysAgo.setDate(
                    date45DaysAgo.getDate() - this.daysForWarning
                  );
                  if (new Date(value) < date45DaysAgo) {
                    this.sickDayRow = row;
                    this.warning45Days = true;
                  }
                }
                try {
                  const sickDayBenefit = (
                    await this.getSickDayBenefit({
                      dateOfService: value,
                      memberIdentityId: this.memberIdentityId,
                    })
                  ).data.value;
                  if (sickDayBenefit.length > 0) {
                    this.planBenefits[row.Identifier] = sickDayBenefit;
                    // console.log(
                    //   "!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
                    //   sickDayBenefit
                    // );
                    this.provider.items[index].PlanBenefit =
                      this.planBenefits[row.Identifier][0];
                    this.provider.items[index].PlanBenefitId =
                      this.planBenefits[row.Identifier][0].Id;
                    this.$refs.table.getDataAsync();
                    this.$forceUpdate();
                    // console.log(`${sickDayBenefit[0].Benefit.Code} - ${translate2(
                    //   sickDayBenefit[0].Benefit,
                    //   "Name"
                    // )}`);
                    this.planBenefit[row.Identifier] = sickDayBenefit[0];

                    this.$emit("plan-benefit", this.planBenefit);
                  } else {
                    this.error = {
                      customMessage:
                        "No Sick Day Benefit found for the given Date of Service",
                    };
                  }
                } catch (error) {
                  this.error = error;
                }

                this.sickDaySubmissionSettings = (
                  await this.getSickDaySubmissionSettings({
                    planIdentityId: this.planIdentityId,
                    memberGroupIdentityId: this.memberGroupIdentityId,
                    dateOfService: value,
                  })
                ).data;
                this.$emit(
                  "sick-day-submission-settings",
                  this.sickDaySubmissionSettings
                );
                if (
                  this.sickDaySubmissionSettings !== null &&
                  this.sickDaySubmissionSettings !== undefined
                ) {
                  this.supportsHalfDays =
                    this.sickDaySubmissionSettings.SupportsHalfDays;
                }
              } else {
                this.planBenefits[row.Identifier] = [];
                this.coveredBenefitCategories[row.Identifier] = [];
                this.coveredBenefits[row.Identifier] = [];
                this.provider.items[index].PlanBenefit = undefined;
                this.provider.items[index].CoveredBenefitCategory = undefined;
                this.provider.items[index].CoveredBenefit = undefined;
              }

              // }

              this.$refs.table.getDataAsync();
            }
          } /*else if (value === null) {
            console.log("Date of service update with null");
            this.provider.items[index][key] = value;
            this.memberGroupIdentityId = null;
            this.planBenefits[row.Identifier] = [];
            this.provider.items[index].PlanBenefit = undefined;
            this.$emit("plan-benefit", this.planBenefit);
            this.sickDaySubmissionSettings = null;
            this.$emit(
              "sick-day-submission-settings",
              this.sickDaySubmissionSettings
            );
            this.supportsHalfDays = false;
          }*/
        } else {
          this.provider.items[index][key] = value;
        }
        if (key === "PlanBenefit") {
          const planBenefit = this.planBenefits[row.Identifier].filter(
            (o) =>
              `${o.Benefit.Code} - ${translate2(o.Benefit, "Name")}` === value
          )[0];
          this.toothCodes[row.Identifier] =
            this.options.Models.ToothCode.filter(
              (o) => o.TreatmentSiteId === planBenefit.Benefit.TreatmentSiteId
            );
          this.planBenefit[row.Identifier] = planBenefit;
          this.searchMonitor = null; //this prevents from executing search plan benefit call after user has selected a plan benefit
          this.$nextTick(() => {
            this.$forceUpdate();
          });
          this.$emit("plan-benefit", this.planBenefit);
          console.log("plan benefit selected", planBenefit);
          console.log(JSON.parse(JSON.stringify(this.planBenefit)));
          if (planBenefit.Benefit.IsHSA) {
            // console.log("Getting HSA Covered Benefits", planBenefit);
            this.coveredBenefits[row.Identifier] = [];
            // this.coveredBenefitCategories[row.Identifier] = [];
            this.coveredBenefitCategories[row.Identifier] =
              await this.getHsaCategories({
                coveredBenefitId: planBenefit.Id,
              });
            this.$nextTick(() => {
              this.$forceUpdate();
            });
          }
        }
        if (key === "CoveredBenefitCategory") {
          this.coveredBenefits[row.Identifier] = [];
          this.provider.items[index][key] = value;
          if (value !== "Dental") {
            this.coveredBenefits[row.Identifier] = (
              await this.getHsaCoveredBenefits({
                coveredBenefitId: this.planBenefit[row.Identifier].Id,
                category: encodeURIComponent(value),
              })
            ).data.value;
          }
          this.$refs.table.getDataAsync();
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
        if (key === "CoveredBenefit") {
          // const coveredBenefit = this.coveredBenefits[row.Identifier].filter(
          //   (o) => o.IsLifestyle ? `${o.LifestyleBenefit.Code} - ${translate2(o.LifestyleBenefit, "Name")}` === value :
          //     `${o.Benefit.Code} - ${translate2(o.Benefit, "Name")}` === value
          // )[0];
          this.coveredBenefit[row.Identifier] = value;
          // this.$emit("covered-benefit", this.coveredBenefit);
          console.log(
            "covered benefit selected",
            this.coveredBenefit[row.Identifier]
          );
        }
        if (key === "DIN") {
          // console.log(
          //   "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@",
          //   this.drugs,
          //   value
          // );
          const din = this.drugs[row.Identifier].filter(
            (o) => `${o.Din}-${o.Name}` === value || o.Din === value
          )[0];
          // console.log(
          //   "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@------------------------------------@@@@@@@@@@@@@@@@@@@@@@@@@@",
          //   this.drugs,
          //   value
          // );
          this.din[row.Identifier] = din;
          this.$emit("din", this.din);
        }
        if (key === "COBAmount") {
          if (
            value === null ||
            value === undefined ||
            value === 0.0 ||
            value === "0.00"
          ) {
            this.provider.items[index].HasCOB = false;
          } else {
            this.provider.items[index].HasCOB = true;
          }
        }

        this.valid = this.validate();
        this.claimSubmission.Claims = this.provider.items;
        // console.log(JSON.stringify(this.claimSubmission.Claims));
        console.log(this.valid);
        this.$emit("valid", this.valid);
        // this.$nextTick(() => {
        //   // let amountTextbox = document.getElementById(
        //   //   "hours-amount-textbox" + row.Identifier
        //   // );
        //   // amountTextbox.style = "text-align:right";
        //   // // this.amountBlur(row);
        //   // const num = parseFloat(row.Amount);
        //   // if (!isNaN(num)) {
        //   //   row.Amount = num.toFixed(2); //this.formatCurrency(num).substring(1);
        //   // } else {
        //   //   row.Amount = null;
        //   // }
        //   console.log(this.provider.items);
        // });
      }
    },
    updateRowAmount(value, row, key) {
      // console.log("update row amount: ", value, row, key);
      const index = this.provider.items.indexOf(
        this.provider.items.filter((o) => o.Identifier === row.Identifier)[0]
      );
      const val = parseFloat(value);
      const existing = parseFloat(this.provider.items[index][key]);
      // console.log(this.provider.items[index][key], existing, val);
      if (isNaN(val)) {
        if (this.provider.items[index][key] !== null) {
          this.provider.items[index][key] = null;
          this.valid = this.validate();
          this.$emit("valid", this.valid);
        }
      } else {
        if (existing !== val) {
          this.provider.items[index][key] = value;
          this.valid = this.validate();
          this.$emit("valid", this.valid);
        }
      }

      // this.$nextTick(() => {
      //   // let amountTextbox = document.getElementById(
      //   //   "hours-amount-textbox" + row.Identifier
      //   // );
      //   // amountTextbox.style = "text-align:right";
      //   // // this.amountBlur(row);
      //   // const num = parseFloat(row.Amount);
      //   // if (!isNaN(num)) {
      //   //   row.Amount = num.toFixed(2); //this.formatCurrency(num).substring(1);
      //   // } else {
      //   //   row.Amount = null;
      //   // }
      //   console.log(this.provider.items);
      // });
      // this.$forceUpdate();
    },
    validate() {
      let valid = true;
      for (let item of this.provider.items) {
        valid = this.isValid(item);
        if (!valid) {
          break;
        }
      }
      return valid;
    },
    isValid(item) {
      // console.log(item);
      if (item.State === "Deleted" || item.State === "Rejected") {
        return true;
      }
      let valid = true;
      switch (this.claimSubmission.CoverageType) {
        case "Health": {
          valid =
            item.Patient !== null &&
            item.Patient !== undefined &&
            item.PlanBenefit !== null &&
            item.PlanBenefit !== undefined &&
            (this.claimSubmission.IsPredetermined ||
              (item.DateOfService !== null &&
                item.DateOfService !== undefined)) &&
            item.ExpenseAmount !== null &&
            item.ExpenseAmount !== undefined;
          break;
        }
        case "Prescription": {
          valid =
            item.Patient !== null &&
            item.Patient !== undefined &&
            item.PlanBenefit !== null &&
            item.PlanBenefit !== undefined &&
            (this.claimSubmission.IsPredetermined ||
              (item.DateOfService !== null &&
                item.DateOfService !== undefined)) &&
            item.ExpenseAmount !== null &&
            item.ExpenseAmount !== undefined;
          if (!valid) {
            break;
          }
          // console.log(item.PlanBenefit);
          if (this.planBenefit[item.Identifier].Benefit.RequiresDIN) {
            valid = item.DIN !== null && item.DIN !== undefined;
          }
          break;
        }
        case "Dental": {
          valid =
            item.PlanBenefit !== null &&
            item.PlanBenefit !== undefined &&
            (this.claimSubmission.IsPredetermined ||
              (item.DateOfService !== null &&
                item.DateOfService !== undefined)) &&
            item.ExpenseAmount !== null &&
            item.ExpenseAmount !== undefined;
          break;
        }
        case "HSA": {
          valid =
            item.Patient !== null &&
            item.Patient !== undefined &&
            item.PlanBenefit !== null &&
            item.PlanBenefit !== undefined &&
            (this.claimSubmission.IsPredetermined ||
              (item.DateOfService !== null &&
                item.DateOfService !== undefined)) &&
            item.ExpenseAmount !== null &&
            item.ExpenseAmount !== undefined &&
            item.CoveredBenefit !== null &&
            item.CoveredBenefit !== undefined;
          if (!valid) {
            break;
          }
          break;
        }
        case "SickDay": {
          if (!this.supportsHalfDays) {
            item.DayDuration = "FullDay";
          }
          valid =
            item.Patient !== null &&
            item.Patient !== undefined &&
            item.PlanBenefit !== null &&
            item.PlanBenefit !== undefined &&
            item.DateOfService !== null &&
            item.DateOfService !== undefined &&
            item.DayDuration !== null &&
            item.DayDuration !== undefined;
          break;
        }
        default: {
          break;
        }
      }
      return valid;
    },
    itemSlotFunc(header) {
      return "item." + header.type.key;
    },
    // async save() {
    //   this.error = null;
    //   this.saving = true;
    //   try {
    //     let items = JSON.parse(JSON.stringify(this.provider.items));
    //     for (let item of items) {
    //       let num = parseFloat(item.Amount);
    //       if (!isNaN(num)) {
    //         item.Amount = num;
    //       } else {
    //         delete item.Amount;
    //       }
    //       num = parseFloat(item.ContributionAmount);
    //       if (!isNaN(num)) {
    //         item.ContributionAmount = num;
    //       } else {
    //         delete item.ContributionAmount;
    //       }
    //       num = parseFloat(item.ExpectedContribution);
    //       if (!isNaN(num)) {
    //         item.ExpectedContribution = num;
    //       } else {
    //         delete item.ExpectedContribution;
    //       }
    //       num = parseFloat(item.ContributionDiff);
    //       if (!isNaN(num)) {
    //         item.ContributionDiff = num;
    //       } else {
    //         delete item.ContributionDiff;
    //       }
    //       delete item.Identifier;
    //       if (item.Employer !== null && item.Employer !== undefined) {
    //         item.EmployerId = item.Employer.Id;
    //         item.Employer = item.Employer.Translations.filter(
    //           (o) => o.LanguageCode === this.language.language
    //         )[0].Name;
    //       }
    //       if (item.Store !== null && item.Store !== undefined) {
    //         item.StoreId = item.Store.Id;
    //         item.Store = item.Store.Translations.filter(
    //           (o) => o.LanguageCode === this.language.language
    //         )[0].Name;
    //       }
    //       if (item.Frequency !== null && item.Frequency !== undefined) {
    //         item.FrequencyId = item.Frequency.Id;
    //         item.Frequency = item.Frequency.Translations.filter(
    //           (o) => o.LanguageCode === this.language.language
    //         )[0].DisplayValue;
    //       }
    //       if (
    //         item.EmploymentType !== null &&
    //         item.EmploymentType !== undefined
    //       ) {
    //         item.EmploymentTypeId = item.EmploymentType.Id;
    //         item.EmploymentType = item.EmploymentType.Translations.filter(
    //           (o) => o.LanguageCode === this.language.language
    //         )[0].DisplayValue;
    //       }
    //       if (item.Gender !== null && item.Gender !== undefined) {
    //         item.GenderId = item.Gender.Id;
    //         item.Gender = item.Gender.Translations.filter(
    //           (o) => o.LanguageCode === this.language.language
    //         )[0].DisplayValue;
    //       }
    //       if (item.TermName !== null && item.TermName !== undefined) {
    //         const termName = item.TermName;
    //         item.TermName = termName.Name;
    //         item.TermYear = termName.Year;
    //         item.TermId = termName.Id;
    //       }
    //     }

    //     await this.addManyPendingHourReports({
    //       planIdentityId: this.selectedPlan.Id,
    //       pendingImportId: this.pendingImportId,
    //       payload: items,
    //     });
    //     this.$emit("save");
    //   } catch (e) {
    //     console.error(e);
    //     this.error = e;
    //   }
    //   this.saving = false;
    // },
    isNumeric(evt) {
      var iKeyCode = evt.which ? evt.which : evt.keyCode;
      if (
        iKeyCode != 46 &&
        iKeyCode > 31 &&
        (iKeyCode < 48 || iKeyCode > 57) &&
        (iKeyCode < 96 || iKeyCode > 105)
      )
        return false;

      return true;
    },
    currencyKeyUp(evt, row, key) {
      var el = evt.srcElement;
      var value = el.value;
      if (!value || value === "") {
        this.updateRow(null, row, key);
        return;
      }
      var start = el.selectionStart;
      var end = el.selectionEnd;
      el.value = parseFloat(value).toFixed(2);
      if (start === 0 && end === 0) {
        end = 1;
      }
      el.setSelectionRange(start, end);
      const num = parseFloat(value);
      if (!isNaN(num)) {
        value = num.toFixed(2); //this.formatCurrency(num).substring(1);
      } else {
        value = null;
      }
      // console.log(value, num);
      this.updateRow(value, row, key);
    },
    currencyKeydown(evt, row, key) {
      const a = this.evaluateShortcut(evt, row, key);
      // console.log(a);
      if (a) {
        return;
      }
      // console.log(evt.keyCode);
      let el = evt.srcElement;
      let value = el.value;
      // console.log("c k d: ", evt, row, key, value);
      if (evt.keyCode == 8 || evt.keyCode == 46) {
        return;
      }
      if (!value) {
        if (evt.keyCode == 190 || evt.keyCode == 110) {
          el.value = value + "0.";
          el.setSelectionRange(2, 2);
        } else if (this.isNumeric(evt)) {
          el.value = value + ".00";
          el.setSelectionRange(0, 0);
        }
      } else if (parseFloat(value) && value.indexOf(".") == -1) {
        let start = el.selectionStart;
        el.value = value + ".00";
        el.setSelectionRange(start, start);
      }
      value = el.value;

      if (
        (evt.keyCode == 190 || evt.keyCode == 110) &&
        value.indexOf(".") >= 0
      ) {
        el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
        evt.preventDefault();
        return;
      }
      // console.log("c k d 2: ");
      if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
        evt.preventDefault();
      } else if (evt.keyCode === 13) {
        evt.preventDefault();
      }
    },
    async setData(items) {
      // this.$nextTick(() => {
      // for (let item of items) {
      //   let amountTextbox = document.getElementById(
      //     "hours-amount-textbox" + item.Identifier
      //   );
      //   amountTextbox.style = "text-align:right";
      //   // this.amountBlur(item);
      //   const num = parseFloat(item.Amount);
      //   if (!isNaN(num)) {
      //     item.Amount = num.toFixed(2); //this.formatCurrency(num).substring(1);
      //   } else {
      //     item.Amount = null;
      //   }
      // }
      // });
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    async getBenefits(search, id, dateOfService) {
      // console.log(
      //   "get benefits: ",
      //   search,
      //   id,
      //   dateOfService,
      //   this.memberGroupIdentityId
      // );
      this.loadingSearch = true;
      try {
        let filter = null;
        if (!this.review) {
          filter = " and AdminOnly eq true and Benefit/IsHSA ne true";
        }
        if (this.claimSubmission.CoverageType === "HSA") {
          filter = " and AdminOnly eq true and Benefit/IsHSA eq true";
        }
        const benefits = (
          await this.getPlanBenefitsForClaimSubmission({
            dateOfService: dateOfService,
            memberIdentityId: this.memberIdentityId,
            search: search,
            coverage: this.claimSubmission.CoverageType,
            filter: filter,
          })
        ).data.value;
        this.planBenefits[id] = benefits;
        this.search[id] = search;
        this.$forceUpdate();
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.loadingSearch = false;
        this.loading = false;
      }
    },
    async getCoveredBenefits(search, claim) {
      console.log(
        "get covered benefits: ",
        search,
        claim
      );
      console.log(JSON.parse(JSON.stringify(this.planBenefit)));
      this.loadingCoveredSearch = true;
      try {
        const benefits = (
          await this.getHsaCoveredBenefits({
            coveredBenefitId:
              claim.PlanBenefitId || this.planBenefit[claim.Identifier].Id,
            category: claim.CoveredBenefitCategory,
            search: encodeURIComponent(search),
          })
        ).data.value;
        this.coveredBenefits[claim.Identifier] = benefits;
        this.coveredSearch[claim.Identifier] = search;
        this.$forceUpdate();
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.loadingCoveredSearch = false;
        this.loading = false;
      }
    },
    getCoveredBenefitNameWithCode(coveredBenefit) {
      return coveredBenefit.IsLifestyle
        ? coveredBenefit.LifestyleBenefit.Code
          ? `${coveredBenefit.LifestyleBenefit.Code} - ${translate2(
              coveredBenefit.LifestyleBenefit,
              "Name"
            )}`
          : translate2(coveredBenefit.LifestyleBenefit, "Name")
        : coveredBenefit.Benefit.Code
        ? `${coveredBenefit.Benefit.Code} - ${translate2(
            coveredBenefit.Benefit,
            "Name"
          )}`
        : translate2(coveredBenefit.Benefit, "Name");
    },
    sortAndAddCategories(benefits, typeOfBenefits) {
      if (!benefits || !benefits.length) return;
      // planBenefits[item.Identifier].map(
      //             (o) => `${o.Benefit.Code} - ${translate2(o.Benefit, 'Name')}`
      //           )
      // const benefitsList = [];
      benefits.sort(
        (a, b) => {
          const aBenefit = a.IsLifestyle ? a.LifestyleBenefit : a.Benefit;
          const bBenefit = b.IsLifestyle ? b.LifestyleBenefit : b.Benefit;
          return aBenefit.Category > bBenefit.Category
            ? 1
            : bBenefit.Category > aBenefit.Category
            ? -1
            : 0;
        }
        // a.Benefit.Coverage > b.Benefit.Coverage
        //   ? 1
        //   : b.Benefit.Coverage > a.Benefit.Coverage
        //   ? -1
        //   : 0
      );
      let benefitsWithHeadersMap = {};
      for (let benefit of benefits) {
        // benefit.DisplayValue = this.$helpers.translate2(
        //   benefit,
        //   "Name",
        //   this.$vuetify.lang.current
        // );
        // if (this.hsaLabel) {
        //   if (
        //     benefit.DisplayValue.toLowerCase().includes("hsa") ||
        //     benefit.DisplayValue.toLowerCase().includes(
        //       "health spending account"
        //     )
        //   ) {
        //     benefit.DisplayValue =
        //       this.$vuetify.lang.current === "fr"
        //         ? this.hsaLabel.Fr
        //         : this.hsaLabel.En;
        //   }
        // }
        let hsaBenefit = benefit.IsLifestyle
          ? benefit.LifestyleBenefit
          : benefit.Benefit;
        let type = hsaBenefit.Category.toLowerCase().includes("drug")
          ? "Drugs"
          : hsaBenefit.Category;
        // if (typeOfBenefits === "PlanBenefits") {
        //   type = hsaBenefit.Coverage.toLowerCase().includes("drug")
        //     ? "Drugs"
        //     : hsaBenefit.Coverage;
        // }
        // let type = benefit.Benefit.Coverage.toLowerCase().includes("drug")
        //   ? "Drugs"
        //   : benefit.Benefit.Coverage;
        if (benefitsWithHeadersMap[type]) {
          benefitsWithHeadersMap[type].push(
            typeOfBenefits === "PlanBenefits"
              ? hsaBenefit.Code !== null && hsaBenefit.Code !== undefined
                ? `${hsaBenefit.Code} - ${translate2(hsaBenefit, "Name")}`
                : translate2(hsaBenefit, "Name")
              : benefit
          );
        } else {
          benefitsWithHeadersMap[type] = [
            typeOfBenefits === "PlanBenefits"
              ? hsaBenefit.Code !== null && hsaBenefit.Code !== undefined
                ? `${hsaBenefit.Code} - ${translate2(hsaBenefit, "Name")}`
                : translate2(hsaBenefit, "Name")
              : benefit,
          ];
        }
      }
      Object.keys(benefitsWithHeadersMap).forEach((category) => {
        benefitsWithHeadersMap[category].sort((a, b) => {
          const aBenefit = a.IsLifestyle ? a.LifestyleBenefit : a.Benefit;
          const bBenefit = b.IsLifestyle ? b.LifestyleBenefit : b.Benefit;
          return aBenefit?.Name > bBenefit?.Name
            ? 1
            : bBenefit?.Name > aBenefit?.Name
            ? -1
            : 0;
        });
        // benefitsWithHeadersMap[category].sort((a, b) =>
        //   a.DisplayValue > b.DisplayValue
        //     ? 1
        //     : b.DisplayValue > a.DisplayValue
        //     ? -1
        //     : 0
        // );
      });
      let benefitsWithHeaders = [];
      // sort coverages but put key "Drugs" first
      const coverages = Object.keys(benefitsWithHeadersMap).sort((a, b) =>
        a === "Drugs" ? -1 : b === "Drugs" ? 1 : a > b ? 1 : b > a ? -1 : 0
      );
      for (let coverage of coverages) {
        benefitsWithHeaders.push({
          header: this.$t(`globals.${coverage.toLowerCase()}`) || coverage,
        });
        benefitsWithHeaders = [
          ...benefitsWithHeaders,
          ...benefitsWithHeadersMap[coverage],
        ];
      }
      // console.log("sorted benefits", benefitsWithHeaders);
      return benefitsWithHeaders;
    },
    async getDrugs(search, id) {
      this.loadingSearch = true;
      try {
        const drugs = (
          await this.getPlanDrugsForClaimSubmission({
            planIdentityId: this.planIdentityId,
            search: search,
          })
        ).data.value;
        this.drugs[id] = drugs;
        this.searchDin[id] = search;
        this.$forceUpdate();
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.loadingSearch = false;
        this.loading = false;
      }
    },
    async deleteClaim(newLine) {
      this.provider.items = this.provider.items.filter(
        (o) => o.Identifier !== this.item.Identifier
      );
      if (this.provider.items.length === 0 || newLine === true) {
        await this.newLine();
      }
      this.$refs.table.getDataAsync();
      this.deleteClaimDialog = false;
      // this.$emit("claims", this.provider.items);
      this.claimSubmission.Claims = this.provider.items;
      this.validate();
      this.$emit("valid", this.valid);
      this.item = null;
      // this.$emit("save");
    },
    evaluateShortcut(evt, row, key) {
      // console.log("key press", evt.keyCode, evt.target.value, key, evt);
      if (evt.keyCode === 13 && key === "COBAmount") {
        const lastItem = this.provider.items[this.provider.items.length - 1];
        if (lastItem.Identifier === row.Identifier) {
          this.newLine();
        } else {
          this.focusRow(lastItem.Identifier);
        }
        return true;
      }
      if (evt.keyCode === 186 && evt.ctrlKey) {
        // ctl+;
        this.rowUp(row, key);
        return true;
      }
      if (evt.keyCode === 191 && evt.ctrlKey) {
        // ctl+/
        this.rowDown(row, key);
        return true;
      }
      // if (evt.keyCode === 37 && evt.shiftKey) {
      //   // left
      //   this.columnLeft(row, key);
      //   return true;
      // }
      // if (evt.keyCode === 39 && evt.shiftKey) {
      //   // right
      //   this.columnRight(row, key);
      //   return true;
      // }
      if (evt.keyCode === 67 && evt.ctrlKey) {
        // ctrl+c
        this.copyRow = JSON.parse(
          JSON.stringify(
            this.provider.items.filter(
              (o) => o.Identifier === row.Identifier
            )[0]
          )
        );
        return true;
      }
      if (evt.keyCode === 86 && evt.ctrlKey) {
        // ctrl+v
        this.pasteLine();
        return true;
      }
      if (evt.keyCode === 88 && evt.ctrlKey && evt.ctrlKey) {
        // ctrl+x
        const item = this.provider.items.filter(
          (o) => o.Identifier === row.Identifier
        )[0];
        this.deleteLine(item);
        return true;
      }
      // console.log("no action shortcut");
      // evt.

      return false;
    },
    async onSearch(evt, row) {
      // console.log(evt.keyCode, evt.target.value, evt.key, JSON.stringify(row));
      if (
        evt.keyCode >= 37 &&
        evt.keyCode <= 40 /*||
        (evt.keyCode >= 112 && evt.keyCode <= 123) ||
        evt.keyCode === 16 ||
        evt.keyCode === 36 ||
        evt.keyCode === 13 ||
        evt.keyCode === 8 ||
        evt.keyCode === 17 ||
        evt.keyCode === 20 ||
        evt.keyCode === 18 ||
        evt.keyCode === 27 ||
        evt.keyCode === 110 ||
        evt.keyCode === 27*/
      ) {
        // arrows
        return;
      }
      if (evt.keyCode === 13) {
        // enter
        return;
      }
      if (evt.keyCode === 9) {
        // tab
        return;
      }
      // if (this.evaluateShortcut(evt, row, "PlanBenefit")) {
      //   return;
      // }
      const obj = { Id: Math.random().toString() };
      this.searchMonitor = obj;
      // console.log("searchmonitor created", this.searchMonitor.Id, obj.Id);
      await this.delay(1200);
      // console.log("1200 ms passed", this.searchMonitor.Id, obj.Id);
      if (this.searchMonitor === null || this.searchMonitor === undefined) {
        return;
      }
      if (this.searchMonitor.Id !== obj.Id) {
        return;
      }
      // console.log(
      //   "1200 ms passed",
      //   this.searchMonitor.Id,
      //   obj.Id,
      //   this.loadingSearch
      // );
      if (this.loadingSearch) {
        return;
      }
      const search = evt.target.value;
      if (this.claimSubmission.IsPredetermined) {
        const now = new Date();
        let day = now.getDate();
        let month = now.getMonth() + 1;
        if (day.toString().length === 1) day = "0" + day.toString();
        if (month.toString().length === 1) month = "0" + month.toString();
        const date =
          now.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z";
        await this.getBenefits(search, row.Identifier, date);
      } else {
        await this.getBenefits(search, row.Identifier, row.DateOfService);
      }

      // await this.delay(10);
      // evt.target.value = search;
      // this.search[row.Identifier] = search;
      // console.log("after get benefits ", evt.target.value);
    },
    async onCoveredSearch(evt, row) {
      // console.log(evt.keyCode, evt.target.value, evt.key, JSON.stringify(row));
      if (
        evt.keyCode >= 37 &&
        evt.keyCode <= 40 /*||
        (evt.keyCode >= 112 && evt.keyCode <= 123) ||
        evt.keyCode === 16 ||
        evt.keyCode === 36 ||
        evt.keyCode === 13 ||
        evt.keyCode === 8 ||
        evt.keyCode === 17 ||
        evt.keyCode === 20 ||
        evt.keyCode === 18 ||
        evt.keyCode === 27 ||
        evt.keyCode === 110 ||
        evt.keyCode === 27*/
      ) {
        // arrows
        return;
      }
      if (evt.keyCode === 13) {
        // enter
        return;
      }
      if (evt.keyCode === 9) {
        // tab
        return;
      }
      // if (this.evaluateShortcut(evt, row, "PlanBenefit")) {
      //   return;
      // }
      const obj = { Id: Math.random().toString() };
      this.searchMonitor = obj;
      // console.log("searchmonitor created", this.searchMonitor.Id, obj.Id);
      await this.delay(1200);
      // console.log("1200 ms passed", this.searchMonitor.Id, obj.Id);
      if (this.searchMonitor.Id !== obj.Id) {
        return;
      }
      // console.log(
      //   "1200 ms passed",
      //   this.searchMonitor.Id,
      //   obj.Id,
      //   this.loadingSearch
      // );
      if (this.loadingCoveredSearch) {
        return;
      }
      const search = evt.target.value;
      await this.getCoveredBenefits(search, row);

      // await this.delay(10);
      // evt.target.value = search;
      // this.search[row.Identifier] = search;
      // console.log("after get benefits ", evt.target.value);
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async onSearchDin(evt, row) {
      // console.log(evt.keyCode, evt.target.value, evt);
      if (
        evt.keyCode >= 37 &&
        evt.keyCode <= 40 /*||
        (evt.keyCode >= 112 && evt.keyCode <= 123) ||
        evt.keyCode === 16 ||
        evt.keyCode === 36 ||
        evt.keyCode === 13 ||
        evt.keyCode === 8 ||
        evt.keyCode === 17 ||
        evt.keyCode === 20 ||
        evt.keyCode === 18 ||
        evt.keyCode === 27 ||
        evt.keyCode === 110 ||
        evt.keyCode === 27*/
      ) {
        // arrows
        return;
      }
      if (evt.keyCode === 13) {
        // enter
        return;
      }
      if (evt.keyCode === 9) {
        // tab
        return;
      }
      // if (this.evaluateShortcut(evt, row, "PlanBenefit")) {
      //   return;
      // }
      const obj = { Id: Math.random().toString() };
      this.searchMonitorDin = obj;
      // console.log("searchmonitor created", this.searchMonitorDin.Id, obj.Id);
      await this.delay(1200);
      // console.log("800 ms passed", this.searchMonitorDin.Id, obj.Id);
      if (this.searchMonitorDin.Id !== obj.Id) {
        return;
      }
      // console.log(
      //   "800 ms passed",
      //   this.searchMonitorDin.Id,
      //   obj.Id,
      //   this.loadingSearch
      // );
      if (this.loadingSearch) {
        return;
      }
      this.getDrugs(evt.target.value /*+ evt.key*/, row.Identifier);
    },
    createRef(item, field) {
      // console.log(`${field}-${item.Identifier}`);
      return `${field}-${item.Identifier}`;
    },
    async newLine() {
      // console.log(JSON.stringify(this.provider.items));
      const newId = Math.random().toString();
      const item = {
        Identifier: newId,
      };
      this.planBenefits[newId] = [];
      this.search[newId] = null;
      this.drugs[newId] = [];
      this.planBenefit[newId] = null;
      this.din[newId] = null;
      if (this.claimSubmission.CoverageType === "Dental") {
        item.DateOfService =
          this.claimSubmission.Claims[
            this.claimSubmission.Claims.length - 1
          ].DateOfService;
      } else if (this.claimSubmission.CoverageType === "SickDay") {
        item.Patient = this.patients[0];
      }
      this.provider.items.push(item);
      await this.$refs.table.getDataAsync();
      // console.log(JSON.stringify(this.provider.items));
      // this.$emit("claims", this.provider.items);
      this.claimSubmission.Claims = this.provider.items;
      // console.log(JSON.stringify(this.claimSubmission.Claims));
      this.$nextTick(async () => {
        // if (this.claimSubmission.CoverageType === "Dental") {
        //   this.$refs[`PlanBenefit-${newId}`][0].focus();
        // } else {
        //   const patientField = this.$refs[`Patient-${newId}`][0];
        //   console.log(patientField);
        //   this.$refs[`Patient-${newId}`][0].focus();
        // }
        // console.log(JSON.stringify(this.provider.items));
        if (this.claimSubmission.CoverageType === "Dental") {
          const field = this.$refs[`DateOfService-${newId}`];
          if (field !== null && field !== undefined && field.length > 0) {
            const el = document.getElementById(
              field[0].$refs.textfield.$refs.input.id
            );
            await this.delay(100);
            el.focus();
          }
        } else {
          const field = this.$refs[`Patient-${newId}`];
          // console.log(field.$refs.autoSelect);
          if (field !== null && field !== undefined && field.length > 0) {
            const el = document.getElementById(
              field[0].$refs.autoSelect.$refs.input.id
            );
            // console.log(el);
            el.focus();
          }
        }
      });
      this.validate();
      this.$emit("valid", this.valid);
    },
    deleteLine(item) {
      this.item = item;
      this.deleteClaimDialog = true;
    },
    async pasteLine() {
      // console.log(
      //   JSON.stringify(this.copyRow),
      //   this.planBenefit,
      //   this.planBenefits,
      //   this.din,
      //   this.drugs
      // );
      if (this.copyRow) {
        const oldId = this.copyRow.Identifier;
        const newId = Math.random().toString();
        this.copyRow.Identifier = newId;
        this.copyRow.Id = null;
        this.copyRow.State = "New";
        this.copyRow.EligibleAmount = null;
        this.copyRow.PaidAmount = null;
        this.search[newId] = null;
        this.provider.items.push(this.copyRow);
        this.planBenefits[newId] = this.planBenefits[oldId];
        this.planBenefit[newId] = this.planBenefit[oldId];
        this.din[newId] = this.din[oldId];
        this.drugs[newId] = this.drugs[oldId];
        this.toothCodes[newId] = this.toothCodes[oldId];
        await this.$refs.table.getDataAsync();
        // this.$emit("claims", this.provider.items);
        this.claimSubmission.Claims = this.provider.items;
        this.$nextTick(async () => {
          // if (this.claimSubmission.CoverageType === "Dental") {
          //   this.$refs[`PlanBenefit-${newId}`][0].focus();
          // } else {
          //   this.$refs[`Patient-${newId}`][0].focus();
          // }
          if (this.claimSubmission.CoverageType === "Dental") {
            const field = this.$refs[`DateOfService-${newId}`];
            if (field !== null && field !== undefined && field.length > 0) {
              const el = document.getElementById(
                field[0].$refs.textfield.$refs.input.id
              );
              await this.delay(100);
              el.focus();
            }
          } else {
            const field = this.$refs[`Patient-${newId}`];
            if (field !== null && field !== undefined && field.length > 0) {
              const el = document.getElementById(
                field[0].$refs.autoSelect.$refs.input.id
              );
              // console.log(el);
              el.focus();
            }
          }
        });
        this.validate();
        this.$emit("valid", this.valid);
        // console.log(JSON.stringify(this.provider.items));
      }
    },
    rowUp(row, key) {
      const item = this.provider.items.filter(
        (o) => o.Identifier === row.Identifier
      )[0];
      const index = this.provider.items.indexOf(item) - 1;
      // console.log(index);
      if (index >= 0) {
        const item = this.provider.items[index];
        this.focusRow(item.Identifier, key);
      }
    },
    rowDown(row, key) {
      // console.log("row down: ", key);
      const item = this.provider.items.filter(
        (o) => o.Identifier === row.Identifier
      )[0];
      const index = this.provider.items.indexOf(item) + 1;
      // console.log(index);
      if (index < this.provider.items.length) {
        const item = this.provider.items[index];
        this.focusRow(item.Identifier, key);
      }
    },
    // columnLeft(row, key) {},
    // columnLeft(row, key) {},
    async focusRow(identifier, key) {
      if (key) {
        const field = this.$refs[`${key}-${identifier}`];
        // console.log(field[0], field[0].$el, field[0].$refs);
        this.$nextTick(() => {
          let el = field[0].$el;
          if (field[0].$refs.input) {
            el = document.getElementById(field[0].$refs.input.id);
          } else if (field[0].$refs.inputRef) {
            el = document.getElementById(
              field[0].$refs.inputRef.$refs.input.id
            );
            // console.log(field[0].$refs.inputRef);
          } else if (field[0].$refs.textfield) {
            el = document.getElementById(
              field[0].$refs.textfield.$refs.input.id
            );
            // console.log(field[0].$refs.textfield);
          }
          // console.log(el);
          el.focus();
        });
      } else {
        // const patientField = this.$refs[`patient-${identifier}`];
        // console.log(patientField, `patient-${identifier}`);
        // if (patientField) {
        //   patientField[0].focus();
        //   return;
        // }
        // const benefitField = this.$refs[`benefit-${identifier}`];
        // if (benefitField) {
        //   benefitField[0].focus();
        //   return;
        // }
        this.$nextTick(async () => {
          if (this.claimSubmission.CoverageType === "Dental") {
            const field = this.$refs[`DateOfService-${identifier}`];
            if (field !== null && field !== undefined && field.length > 0) {
              const el = document.getElementById(
                field[0].$refs.textfield.$refs.input.id
              );
              await this.delay(100);
              el.focus();
            }
          } else {
            const field = this.$refs[`Patient-${identifier}`];
            if (field !== null && field !== undefined && field.length > 0) {
              const el = document.getElementById(
                field[0].$refs.autoSelect.$refs.input.id
              );
              // console.log(el);
              el.focus();
            }
          }
        });
      }
    },
    adjudicateClaim(item) {
      this.item = item;
      this.adjudicateDialog = true;
    },
    explainClaim(item) {
      this.item = item;
      this.explainDialog = true;
    },

    deleteClaimCall(item) {
      this.item = item;
      this.deleteDialog = true;
    },
    async tryDeleteClaim() {
      try {
        this.loading = true;
        await this.deleteClaimById({
          claimId: this.item.Id,
        });
        this.item = null;
        this.$emit("reload-claim-submission");
        this.deleteDialog = false;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async tryAdjudicate() {
      try {
        this.loading = true;
        // const claim =
        await this.adjudicateClaimById({
          claimId: this.item.Id,
        });

        // const item = this.provider.items.filter(
        //   (o) => o.Identifier === this.item.Identifier
        // );
        // const index = this.provider.items.indexOf(item);
        // this.provider.items[index] = claim;
        // this.$refs.table.getDataAsync();
        // this.claimSubmission.Claims = this.provider.items;
        // this.validate();
        // this.$emit("valid", this.valid);
        this.item = null;
        this.$emit("reload-claim-submission");
        this.adjudicateDialog = false;
        this.message =
          "components.claims.claims_table.adjudicated_successfully";
        this.snackbar = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    isReadOnly(item) {
      // All claims that status IS NOT Pended should be readonly
      if (item.State === null || item.State === undefined) {
        return false;
      }
      return this.review && item.State !== "Pended" && item.State !== "New";
    },
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    rejectClaim(item) {
      this.item = item;
      this.rejectDialog = true;
    },
    async tryReject() {
      try {
        this.loading = true;
        await this.rejectClaimById({
          claimId: this.item.Id,
          payload: {
            Explanation: this.rejectExplanation,
          },
        });
        this.item = null;
        this.rejectExplanation = null;
        this.$emit("reload-claim-submission");
        this.rejectDialog = false;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    pendClaim(item) {
      this.item = item;
      this.pendDialog = true;
    },
    async tryPend() {
      try {
        this.loading = true;
        await this.pendClaimById({
          claimId: this.item.Id,
          payload: {
            Explanation: this.pendExplanation,
          },
        });
        this.item = null;
        this.pendExplanation = null;
        this.$emit("reload-claim-submission");
        this.pendDialog = false;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    displayReadonlyDIN(item) {
      if (item.DIN === null || item.DIN === undefined) {
        return;
      }
      if (typeof item.DIN === "object") {
        return `${item.DIN.Din}-${item.DIN.Name}`;
      }
      return item.DIN;
    },
  },
};
</script>
